import { commaedInteger, formatDigits } from '../scripts/weapp-commons/util/string-util';
/**
 * @generated
 */

export const textZhCn = {
  c: `预付款的100%`,
  liquidProductsNotice: (className: string) =>
    `请留意！ ※如订单<span class=${className}>含有液体</span>。如搭乘飞机<span class=${className}>请托运</span>。`,
  airports: {
    airportSwitched: `已变更取货位置。`,
    areYouSureToSwitchAirport: `真的要更改取货柜台吗？`,
    map: `地图`,
    mapTitle: (shop: string) => `${shop}的取货地点说明`,
    metaDescription: (shop: string) =>
      `通过玩尽日本购物，来日本旅行时即可在${shop}领取已购买的商品。让日本旅行更轻松，请使用玩尽日本免税购物！`,
    pickupAirport: `取货点`,
    selectPickupAirport: `选择取货点`,
    switchingAirportWouldClearCart: `更改取货柜台会清空当前购物车`
  },
  allVisitorCampaign: {
    allYouCanUse: (highlight: string, currency: string) =>
      `任何人都能使用的<span class=${highlight}>1,000<span class=${currency}>日元</span>优惠劵</span>`,
    click: `点击`,
    getCoupon: `领取优惠券`,
    getSoon: `立即领取`
  },
  amounts: {
    checkVendorAmount: `请确认各供应商的总金额`,
    consumptionTax: `消费税`,
    discounted: `折扣`,
    drugPurchasableAnnotation: `杉药房购物车中的总金额超过 1,000 日元时可用。`,
    explanationOfLocalCurrencyAmount: (date: string) =>
      `※日元以外的价格为根据 ${date} 汇率计算出的参考价格。\n您的实际支付金额将由支付服务决定。`,
    maximumTotalAmountIs500000JPY: `最高订单金额为500,000 日元`,
    minimalTotalAmountIs1000Jpy: `最低购买金额为1000日元`,
    minimalTotalAmountIs3000Jpy: `最低购买金额为3000日元`,
    minimalTotalAmountIs5000Jpy: `最低订单金额为5,000 日元`,
    orderAmount: `订单金额`,
    purchaseAmount: `支付金额`,
    shopDiscountAmount: `进站票折扣`,
    subtotalAmount: `小计`,
    taxFree: `免税`,
    taxFreeIfTotalAmountExceeds5kJpy: `商品总金额超过5,000日元即可免消费税`,
    totalAmount: `总金额`
  },
  announce: {
    noteText: `※由于日本新年期间物流停运，12月30日至1月7日期间取货的订单目前暂停受理。1月8日起可照常支付。`
  },
  auth: {
    accountNotYet: `还不是会员？`,
    creditCardList: `信用卡管理`,
    lookForwardToServingYouAgain: `欢迎再次使用！`,
    signIn: `登录`,
    signUp: `注册`,
    signUpNow: `马上注册`,
    signedOut: `已退出登陆。`,
    signUpCoupon: {
      alt: `500日元`,
      getNow: `立即领取`,
      title: `注册会员`
    }
  },
  banner: {
    cosmetics: {
      featured: `特集`,
      mustBuy: `必买\n日本热销美妆商品`,
      postCovid: `后疫情时代必备品`
    },
    skincare: {
      recommended: `编辑部推荐\n热门单品`,
      specialSet: `夏季护肤\n特辑`
    },
    snacks: {
      haveATry: `吃吃看呀`,
      souvenirs: `伴手礼`
    },
    walkthrough: {
      amazingTaxFreeService: `全新免税服务`,
      onlyIn3min: `最快3分钟`,
      seeMoreAmazingSights: `享受观光乐趣`,
      title: `旅行前預約，\n在机场取货`
    }
  },
  brands: {
    cosmeticBrand: `化妆品品牌`,
    cosmeticBrandTitle: (cosmeticBrand: string) => `${cosmeticBrand}免税商品`,
    description: `品牌一览。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
    searchResult: `搜索结果`,
    titleName: `品牌`,
    viewAll: `查看所有品牌`,
    index: {
      strokeCount: `画`
    },
    list: {
      title: `品牌一览`
    },
    meta: {
      description: (brand: string) =>
        `${brand}商品一览。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
      descriptionWithParams: (brand: string, category: string) =>
        `${brand} ${category}商品一览。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
      title: (brand: string) => `${brand}日本免税品一览`,
      titleWithParams: (brand: string, category: string) => `${brand} ${category}日本免税品一览`
    },
    search: {
      placeholder: `输入品牌名称`
    },
    slug: {
      description: (brand: string) =>
        `${brand}商品一览。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`
    }
  },
  campaign: {
    present: `小礼品`,
    bank: {
      esun: `TODO: campaign.bank.esun@zh_cn`,
      taiwanMobile: `TODO: campaign.bank.taiwanMobile@zh_cn`,
      title: `超多优惠活动火热进行中！立即查看活动详情！`,
      ubot: (price: string, discount: string) => `TODO: campaign.bank.ubot@zh_cn`,
      yuanta: `TODO: campaign.bank.yuanta@zh_cn`
    },
    fancl: {
      addNowToCart: `立即加入购物车`,
      goodDealPrice: (price1: string, price2: string) => `通常${price1}日元（含税）商品现在购买立省${price2}日元`,
      limitedSpecialSet: `FANCL限量特别套装！`,
      specialSetPrice: `特别套装价格`,
      usageStep: `使用步骤`,
      brighteningSet: {
        present: `＜小礼品＞纳米温和卸妆油120ml`,
        product1: `・速净卸妆油<黑炭&速效> 120ml`,
        product2: `・矿物洁面凝胶　120g`,
        product3: `・亮白肌底液-滋润型〈医药部外品〉 30ml`,
        product4: `・亮白精华〈医药部外品〉 18ml`,
        product5: `・亮白肌底乳液-滋润型〈医药部外品〉 30ml`,
        product6: `・莹亮焕白精华面膜 6片`,
        product7: `・物理防晒霜SPF50+ 60ml`,
        title: `美白套装`,
        whatMelanin: `※1 美白功效指抑制黑色素的生成，预防色斑和雀斑。\n（纳米温和卸妆油、矿物洁面凝胶、物理防晒霜SPF50+除外）`
      },
      og: {
        description: `玩尽日本首次推出FANCL 限量特别套装！ 超值购，就上玩尽日本线上免税店！`,
        title: `玩尽日本首次推出FANCL 限量特别套装！ | 玩尽日本购物`
      },
      pores: {
        present: {
          description: `宛如精华液般的“亲肤柔滑”的卸妆油，卸妆同时不摩擦皮肤。打造光滑平整，不见毛孔的水嫩肌肤。`,
          name: `卸妆`,
          title: `纳米温和卸妆油 60ml`
        },
        step1: {
          description: `酵素洁面粉，深层清洁毛孔污垢。`,
          name: `洁面`,
          title: `深层清洁酵素洁面粉 30个`
        },
        step2: {
          description: `轻松去除黑头等污垢！涂抹五分钟后只需清水冲洗即可！`,
          name: `洁净`,
          title: `黑头清透涂抹面膜　40g`
        },
        step3: {
          description: `局部用精华液，着重改善毛孔问题，减少面部油光，使皮肤细致干爽光滑。`,
          name: `毛孔精华`,
          title: `毛孔紧致精华 8g`
        },
        step4: {
          description: `每日使用，有效祛除毛孔污垢，解决肌肤粗糙问题，令肌肤清爽通透。`,
          name: `洁面`,
          title: `矿物洁面凝胶　120g`
        },
        step5: {
          description: `宛如精华液般的“亲肤柔滑”的卸妆油，卸妆同时不摩擦皮肤。打造光滑平整，不见毛孔的水嫩肌肤。`,
          name: `卸妆`,
          title: `纳米温和卸妆油 120ml`
        },
        step6: {
          description: `解决对于毛孔深度清洁的需求。专为「对鼻翼皮肤污垢感到烦恼」或「希望肌肤更加光滑细致」的人群打造！`,
          name: `卸妆`,
          title: `速净卸妆油<黑炭&速效> 120ml`
        }
      },
      poresSet: {
        present: `＜小礼品＞纳米温和卸妆油 60ml`,
        product1: `・深层清洁酵素洁面粉 30个`,
        product2: `・黑头清透涂抹面膜　40g`,
        product3: `・毛孔紧致精华 8g`,
        product4: `・矿物洁面凝胶　120g`,
        product5: `・纳米温和卸妆油120ml`,
        product6: `・速净卸妆油<黑炭&速效> 120ml`,
        title: `毛孔护理套装`
      },
      present: {
        description: `宛如精华液般的“亲肤柔滑”的卸妆油，卸妆同时不摩擦皮肤。打造光滑平整，不见毛孔的水嫩肌肤。`,
        name: `卸妆`,
        title: `纳米温和卸妆油120ml`
      },
      step1: {
        description: `解决对于毛孔深度清洁的需求。专为「对鼻翼皮肤污垢感到烦恼」或「希望肌肤更加光滑细致」的人群打造！`,
        name: `卸妆`,
        title: `速净卸妆油<黑炭&速效> 120ml`
      },
      step2: {
        description: `每日使用，有效祛除毛孔污垢，解决肌肤粗糙问题，令肌肤清爽通透。`,
        name: `洁面`,
        title: `矿物洁面凝胶　120g`
      },
      step3: {
        description: `滋润型药用美白化妆液。质地润泽浓稠，打造健康透亮肌肤。`,
        name: `肌底液`,
        title: `亮白肌底液-滋润型〈医药部外品〉 30ml`
      },
      step4: {
        description: `針對色斑從根本進行修復，實現無瑕透亮的肌膚`,
        name: `精华`,
        title: `亮白精华〈医药部外品〉 18ml`
      },
      step5: {
        description: `滋润型药用美白乳液。质地润泽浓稠，深入持久保湿，打造焕亮光泽肌肤。`,
        name: `乳液`,
        title: `亮白肌底乳液-滋润型〈医药部外品〉 30ml`
      },
      step6: {
        description: `每片面膜中都含有超过一整支含量的美白精华。`,
        name: `面膜`,
        title: `莹亮焕白精华面膜 6片`
      },
      step7: {
        description: `抗汗、抗水，有效阻隔强烈紫外线等外部刺激，呵护肌肤！`,
        name: `防晒`,
        title: `物理防晒霜SPF50+ 60ml`
      }
    },
    jcb: {
      aboutFlow1: `<em>最短在希望取貨日的3天前</em><br>上網或使用APP完成預約購買`,
      aboutFlow2: `<em>所需時間約3分鐘！</em><br>前往置物櫃，<br>進行人臉辨識及護照確認，<br>即可完成免稅手續並結帳`,
      aboutFlow3: `領取放在<em>置物櫃</em>裡<br>的購入商品`,
      aboutNote: `（取貨地點可選擇日本全國指定的機場或是車站）`,
      aboutText: `利用於全國指定車站或機場內設置的<em>置物櫃型自動販賣機</em>，<br>即可領取已預約商品的線上免稅購物服務。`,
      flow1: `TODO: campaign.jcb.flow1@zh_cn`,
      flow2: `按下詳細金額旁邊的「<em>選擇優惠券</em>」（英語則是「<em>Select Coupon</em>」），選擇並輸入上面的優惠券代碼`,
      flow3: `於下一個結帳畫面選擇「<em>JCB</em>」，完成預約購買`,
      meta: `JCB會員限定企劃！只要購物1萬日圓以上，就能折抵免稅商品2,000日圓`,
      noteForCondition: `※此為折扣前的金額　\n※部分商品不適用此折扣活動`,
      noteForFlow: `※1萬日圓以上的訂單內容皆須為適用折扣的商品`,
      period: `2023年10月16日（一）  〜 2024年1月15日（一） （台灣時間22:59為止）`,
      shoppingTitle: `即將接近一年的尾聲，看看有哪些適合拿來送禮的美食伴手禮`,
      banner: {
        notice: `※不適用JCB優惠券`,
        title: `WAmazing 其他服務`
      },
      notes: {
        note1: `・除日本及香港發行的卡，其餘國家及地區的JCB信用卡皆為適用對象。`,
        note10: `・參加本活動的貴賓，即代表同意將個人資訊提供給完美行以及JCB International Inc.。`,
        note2: `・需使用JCB信用卡結帳。`,
        note3: `・優惠券1人僅限使用1次。`,
        note4: `・優惠券無法併用。`,
        note5: `・優惠券的使用期限至日本時間2024年1月15日23:59。`,
        note6: `・無法將本活動的權利轉讓給他人，亦無法轉換成現金。`,
        note7: `・本活動可能會在未事先通知的情況下變更活動內容或終止活動，敬請見諒。`,
        note8: `・部分商品不適用本活動。`,
        note9: `・將於資訊公開時，一併記載確切的活動舉辦期間。\n本活動有可能於上述時間結束後仍持續進行。`
      },
      shopping: {
        brandTitle153: `〈正品〉資生堂`,
        brandTitle426: `〈正品〉SK-II`,
        brandTitle7558: `柿之種米果`,
        brandTitle8472: `瀨戶內檸檬農園`,
        brandTitle9422: `沖繩南風堂`,
        brandTitle9516: `巖手屋`,
        brandTitle9538: `〈正品〉FANCL`,
        brandTitle9597: `〈正品〉黛珂`,
        catch153: `高人氣抗老護理保養品`,
        catch426: `SK-II熱銷品`,
        catch6842: `北海道品牌`,
        catch6937: `送禮人氣No.1`,
        catch7534: `門市熱銷不斷`,
        catch7558: `東京限定`,
        catch7696: `內含皇冠哈密瓜果肉`,
        catch8472: `來自檸檬產量日本第一的廣島`,
        catch9422: `來自沖繩縣、回購不斷的勁辣好滋味`,
        catch9516: `岩手知名甜點`,
        catch9538: `完美行限定的正品`,
        catch9597: `獲獎無數的熱銷美妝No.3`,
        description153: `打造水潤彈力肌膚的美容晚霜。好推不黏膩，能確實服貼肌膚。`,
        description426: `SK-II 最暢銷的美白精華液。防止肌膚因為紫外線而產生斑點及暗沉，打造由內到外的透亮肌膚。`,
        description6842: `加入大量北海道牛奶的「牛奶口味」、以及搭配知名的高級抹茶產地——西尾產抹茶的「抹茶牛奶口味」，總計共6種口味！`,
        description6937: `小包裝設計，一次享用五種口味，最適合拿來當伴手禮！`,
        description7534: `由熟悉起司的專業職人們監製，打造出味道、香氣、口感皆十分講究的起司點心。`,
        description7558: `甜辣天丼風味、文字燒風味、濃厚法式多蜜醬風味、高湯咖哩風味，每種風味各有4包`,
        description7696: `加入最高級的哈密瓜——皇冠哈密瓜果肉的果凍與布丁組合`,
        description8472: `外頭酥脆、中間鬆軟。有著清爽檸檬風味且不會過甜，嚐過就停不下來的美味，非常推薦於下午茶時享用。`,
        description9422: `辛辣口感讓人無法抗拒。加入沖繩島唐辛子的酥脆蝦餅`,
        description9516: `以小麥及芝麻為材料，再加上少許的鹽，製作出擁有樸素的基本口味，並搭配各種材料變化出不同風味的南部煎餅。`,
        description9538: `推薦給零毛孔肌膚的卸妝油及精華液5款商品組合。現在購買還多贈送1罐卸妝油。`,
        description9597: `多次榮獲最佳美妝大賞No.1！即使睡眠不足，肌膚看起來仍像是多睡3小時般亮麗的修復霜。`,
        moreButton1: `編輯部推薦伴手禮`,
        moreButton2: `查看更多日本全國伴手禮`,
        moreButton3: `查看更多推薦商品`,
        notice: `※目前以2023年8月底的匯率做計算。實際購買金額以購買當下的最新匯率為準。`,
        sectionTitle1: `即將接近一年的尾聲，看看有哪些適合拿來送禮的美食伴手禮`,
        sectionTitle2: `日本人超推！只有當地才買得到的伴手禮`,
        sectionTitle3: `現在買最划算的必買商品`,
        text153: `怡麗絲爾 膠原緊膚晚霜 W`,
        text426: `超肌因鑽光淨白精華 30ml`,
        text6842: `LANGUE DE CHAT 30片混裝`,
        text6937: `薯條餅乾迷你禮盒 10入`,
        text7534: `起司奶油脆餅 12塊裝`,
        text7558: `東京限定　龜田土產柿之種`,
        text7696: `靜岡皇冠哈密瓜果凍 8個入（含3支特製金湯匙）`,
        text8472: `銀鈴檸檬蛋糕`,
        text9422: `島唐辛子辣味蝦餅（小）`,
        text9516: `Nico Nico 南部煎餅`,
        text9538: `【毛孔淨化套組】`,
        text9597: `Liposome Advanced Repair Cream 50g`
      }
    }
  },
  cart: {
    addToCart: `放入购物车`,
    addedToCart: `已放入购物车`,
    cartCollections: `购物车一览`,
    cartIsEmpty: `购物车中还没有商品`,
    cartIsEmptyToTop: `返回首页`,
    cartIsEmptyToTopAndAddProducts: `返回首页\n继续购物。`,
    continueShopping: `继续购物`,
    detail: `详细金额`,
    insufficientAmountToPurchase: (insufficientAmount: number) => `请再添加${insufficientAmount}日元的商品即可下订单`,
    proceedToForm: `创建订单`,
    purchasable: `可订购`,
    showToCart: `查看购物车`,
    taxFreeShopOrderingCondition: (shopName: string) => `${shopName}的每次最低消费金额为5000日元（打折后总额）`,
    taxableShopOrderingCondition: (shopName: string) => `${shopName}的每次最低消费金额为1000日元`,
    title: `购物车`,
    agree: {
      addToCart: `同意并加入购物车`
    },
    cannotPickup: {
      removeItem: `不能領取,,请删除。`
    },
    confirm: {
      addToCart: `确认后加入购物车`,
      checkNotes: {
        addToCart: `确认注意事项并加入购物车`
      }
    }
  },
  cartError: {
    productNotOrderable: `商品还在准备中`
  },
  category: {
    largeCategoryDescription: (largeCategory: string) =>
      `可先在网上购买日本人气知名${largeCategory}，来日本旅行期间即可在指定机场领取已购买商品。使用玩尽日本购物，在日本旅行期间能以更轻松的方式、更划算的价格买到日本各种商品。`,
    middleCategoryDescription: (middleCategory: string, largeCategory: string) =>
      `可先在网上购买日本人气知名${middleCategory} ${largeCategory}，来日本旅行期间即可在指定机场领取已购买商品。使用玩尽日本免税购物，在日本旅行期间能以更轻松的方式、更划算的价格买到日本各种商品。`,
    middleCategoryMetaTitle: (middleCategory: string, largeCategory: string) =>
      `日本必买${middleCategory}・${largeCategory}`,
    popularSmallCategory: `人气小分类`,
    showVendorOnlyDrug: `SUGI杉药局 川口户塚店`,
    smallCategoryDescription: (smallCategory: string, middleCategory: string) =>
      `可先在网上购买日本人气知名${smallCategory} ${middleCategory}，来日本旅行期间即可在指定机场领取已购买商品。使用玩尽日本免税购物，在日本旅行期间能以更轻松的方式、更划算的价格买到日本各种商品。`,
    smallCategoryMetaTitle: (smallCategory: string, middleCategory: string) =>
      `日本必买${smallCategory}・${middleCategory}`,
    title: `分类`,
    meta: {
      description: (categoryName: string) =>
        `${categoryName}商品一览。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
      title: (categoryName: string) => `${categoryName}日本免税品一览`
    }
  },
  categoryRanking: {
    seeMore: `查看更多分类排行`,
    title: `分类排行`
  },
  commons: {
    after: (time: string) => `${time}后(日本时间)`,
    afterShipping: `已发货`,
    all: `全部`,
    autoApplyDiscountOnAddToCart: `加入购物车后自动生效。`,
    autoApplyDiscountOnAddToCartDesc: `加入购物车后自动生效。可与其他优惠券同时使用。`,
    automaticCancel: (time: string) => `${time}后(日本时间)自动取消`,
    before: `之前`,
    beforeShipping: `未发货`,
    bestJapanese: `日本必买`,
    cancelFee: `取消费`,
    choice: `选择`,
    cosmetics: `热销护肤品、化妆品`,
    dateAndTime: (year: string, month: string, day: string, hour: string, minute: string) =>
      `${year}年${month}月${day}日 ${hour}:${minute}起`,
    dismiss: `关闭`,
    download: `下载`,
    errorOccurred: `发生错误`,
    exclamationMark: `！`,
    foldContents: `收起`,
    goBack: `返回`,
    hot: `人气`,
    lessThan: `以下`,
    mustBuy: `日本推荐`,
    noShow: `未取消也未提货`,
    ok: `OK`,
    pinchOut: `用双指放大`,
    proceed: `继续`,
    purchaseTaxFree: `免税购买`,
    qualities: `特色`,
    quantity: `数量`,
    remove: `移除`,
    showMore: `查看更多`,
    showMoreDetails: `立即查看`,
    signUp: `点击注册`,
    snacks: `点心零食`,
    specialDeals: `优惠信息`,
    tax: `含税`,
    taxFreeProducts: `免税商品`,
    taxFreeRegularPrice: `正常价格（免税）`,
    taxFreeSalePrice: `优惠价格（免税）`,
    taxProducts: `课税商品`,
    topPage: `首页`,
    tryAgain: `请从头再试。`,
    undisclosed: `非公开`,
    until: (time: string) => `${time}前(日本时间)`,
    vendor: `供应商`,
    wamazingShop: `玩尽日本购物`,
    yen: `日元`,
    aboutWamazingShop: {
      desc: `在线购买！通过设置在日本各地车站及机场的取货柜，可以在回国前轻松领取商品。`,
      title: `玩尽日本 购物特点`
    },
    campaign: {
      seeMoreDetail: `查看优惠活动详情`
    },
    date: {
      day: `日`,
      month: `月`,
      year: `年`
    },
    meta: {
      title: `在日旅行轻松购买伴手礼｜玩尽日本购物`
    },
    notice: {
      notContainKobayashiPharmaceuticalBeniKoji: `玩尽日本销售的任何商品，均不使用近期被报道对健康有害的小林制药红曲原材料。`
    },
    url: {
      copied: `链接已复制`
    }
  },
  complementary: {
    addNToCart: (count: number) => `将${count}件商品放入购物车`,
    addToCart: `放入购物车`,
    count: (count: number) => `${count}件合计`,
    title: `例：商品的味道、使用方便性`,
    viewDetail: `查看详情`
  },
  counterPickup: {
    jttpRemark: `玩尽日本 购物目前暂不支持JTTP。`,
    vjmGuideUrl: `https://services.digital.go.jp/zh-cmn-hans/visit-japan-web/guide/`,
    vjmRemark: (className: string, childClassName: string, url: string) =>
      `如需在指定设施领取免税商品，<span class=${className}>必须在入境日本后<a class=${childClassName} href=${url} target="_blank">注册VJW（Visit Japan Web）</a></span>`,
    guide: {
      cancellationPolicy: {
        description: `预订时支付的20%订金将作为取消费用。如选择人工取货并且在预订时已支付全额，取消后将退还80%的购买金额。`,
        refund: {
          description: `如符合退款条件，系统将于取消时立即进行退款处理。根据选择的支付方式，实际到账可能会需要一段时间。退款将根据您选择的支付方式原路退回。`
        }
      },
      caution: {
        text1: `确认取货地点\n是否正确`,
        text2: `确认取货日期\n是否正确`,
        text3: `如选择取货柜自助取货，请务必\n携带护照`,
        text4: `确保手机网络\n畅通`,
        title: `注意事项`
      },
      counter: {
        help: {
          description: `请咨询玩尽日本客服`,
          descriptionDetail: (className: string) =>
            `如果在领取商品时遇到困难，请扫描工作人员提供的<span class=${className}>咨询二维码</span>，或访问以下网址（https://p.wamazing-cn.com/kaimono/pickup_support）<span class=${className}>联系玩尽日本客服</span>。`,
          title: `如果人工取货时遇到问题...`
        },
        step1: {
          description1: (className: string) =>
            `人工取货时办理免税手续，需提前<span class=${className}>注册</span>Visit Japan Web，生成<span class=${className}>免税二维码</span>。`,
          description2: `Visit Japan Web是什么？`,
          description3: `查看Visit Japan Web的使用流程`,
          title: `请于入境前注册Visit Japan Web(VJW)`
        },
        step2: {
          description: (className: string) =>
            `指定<span class=${className}>取货地点</span>、<span class=${className}>日期</span>和<span class=${className}>时间</span>`,
          title: `选择取货地点`,
          button: {
            title: `人工取货地点一览`
          }
        },
        step3: {
          description1: `请在取货前生成免税二维码`,
          title: `通过VJW生成免税二维码`,
          button: {
            title: `查看免税二维码的生成方法`
          }
        },
        step4: {
          description: (className: string) =>
            `取货时，请向工作人员出示「取货二维码」和在步骤3生成的「免税二维码」，领取商品。\n取货二维码请访问我的页面中的订单列表查看。\n如有任何疑问，<span class=${className}>请联系玩尽日本客服</span>，请勿咨询现场工作人员。`,
          title: `领取商品`
        }
      },
      customerSupport: {
        description: `如因不可抗力因素导致未能领取商品，可申请全额退款。届时请联系客服咨询。\n※用户个人原因取消订单不在退款范围内。如因公共交通延误导致无法领取商品，提供延误证明书可办理退款。`,
        heading: `退款保证说明`,
        subHeading: `首次使用也无须担心`,
        title: `若因故无法领取商品，将全额退款！`
      },
      faq: {
        message1: `取货时需要准备些什么？`,
        message10: `玩尽日本的所有取货柜均设于车站或机场内。\n所有取货手续必须在通过安检前（出境前）完成。\n建议在办理登机手续前先前往取货柜领取商品。\n※若在入境日本时取货，完成入境手续后即可前往取货柜。\n※如购买的商品中含有超过100ml的液体，建议办理托运。\n\n详细的取货地点和手续方法，请访问以下链接确认。\n<a href="https://p.wamazing-cn.com/kaimono/guide">https://p.wamazing-cn.com/kaimono/guide</a>\n※取货时需要携带内置IC芯片的护照和有效的上陆许可贴纸，敬请注意。`,
        message11: `在取货柜前完成付款手续后，发现取货柜中没有商品怎么办？`,
        message12: `非常抱歉。如果遇到此类情况我们会为您全额退款或将商品邮寄至您的家中。届时烦请咨询客服中心。\n<a href="https://p.wamazing-cn.com/kaimono/support">https://p.wamazing-cn.com/kaimono/support</a>`,
        message2: `【取货柜自助取货】\n取货时需要面部识别以确认本人身份。请务必事先准备下列物品。\n\n①取货者本人带IC芯片的护照。（不可使用他人护照）没有IC芯片的护照无法取货。\n\n②上陆许可贴纸\n※入境时会贴在您的护照上\n※机组人员、转机旅客或是持有日本在留资格者，在入境时不会贴有「上陆许可贴纸」，则无法使用取货柜。\n\n③支付时需要联网，请务必确保手机的网络连接。\n\n【面对面人工取货】\n①Visit Japan Web的免税二维码\n请提前生成免税二维码。\nhttps://services.digital.go.jp/visit-japan-web/guide\n\n②取货时需要联网，请务必确保手机的网络连接。`,
        message3: `超过预约取货时间仍未完成取货怎么办？`,
        message4: `若超过预约取货的一定时间后仍未取货，您的订单将被自动取消。届时会产生取消费用，商品也将无法领取，敬请注意。`,
        message5: `可以在预约的时间以外取货吗？`,
        message6: `非常抱歉，在预约的时间以外恕无法取货。`,
        message7: `可以在出境日以外的时间领取商品吗？`,
        message8: `在日本逗留的期间内随时都可以取货，敬请放心。但是请务必在您选择的日期前来取货。`,
        message9: `取货柜的位置在哪里？是海关前还是出境大厅？`,
        title: `常见问题`
      },
      locker: {
        step1: {
          description: (className: string) =>
            `日本各地<span class=${className}>机场、车站和巴士中心</span>等地设有无人取货柜，轻松领取购买的商品`,
          title: `选择取货地点`
        },
        step2: {
          description: (className: string) =>
            `在取货柜前，从<span class=${className}>预约详情页面</span>点击<span class=${className}>「输入4位数字」</span>，并输入取货柜屏幕上显示的<span class=${className}>4位数字</span>。`,
          title: `确认二维码`
        },
        step3: {
          description1: (className: string) => `※需要<span class=${className}>内置芯片的护照</span>。`,
          description2: `※取货时，请务必携带内置芯片的护照以进行本人身份确认。`,
          title: `护照信息确认`
        },
        step4: {
          description: `请在取货柜前，点击订单记录页面中的「输入4位数字」，输入取货柜屏幕显示的4位数字。`,
          title: `取货时付款`
        },
        step5: {
          description: (className: string) => `请按照取货柜显示屏显示的步骤<span class=${className}>领取商品。</span>`,
          title: `领取商品`
        }
      },
      pickup: {
        title: `取货地点`
      },
      table: {
        title: `取货柜取货于人工取货的区别`,
        row1: {
          column1: `没有`,
          column2: `有`,
          header: `是否有工作人员在场`
        },
        row2: {
          column1: `・预订时：20%\n・取货时：80%`,
          column2: `・预订时：100%\n・取货时：ー`,
          header: `支付方式`
        },
        row3: {
          column1: `需要`,
          column2: `不需要`,
          header: `注册VJW`
        },
        row4: {
          column1: `・内置芯片的护照\n・上陆许可`,
          column2: `・VJW的免税二维码`,
          header: `取货时所需的准备`
        },
        row5: {
          column1: `暂不支持`,
          header: `JTTP`
        }
      }
    }
  },
  coupons: {
    acquired: `已领取`,
    allYouCanUse: (highlight: string) => `任何人都能使用的<span class=${highlight}>优惠券</span>`,
    allYouCanUseText: `任何人都能使用的优惠券`,
    canBeUsedForJcb: `※所选优惠券仅限使用JCB信用卡。请变更信用卡，或删除/变更优惠券。`,
    canBeUsedForWamazingProducts: `※优惠券仅限用于玩尽日本商品。`,
    consumableLimitReached: `发放结束`,
    coupon: `优惠券`,
    couponForEveryone: `所有人都能使用`,
    discountByAmount: (amount: number) => `优惠 ${amount} 日元`,
    discountByRate: (rate: number) => `优惠 ${formatDigits(100 * rate)}%`,
    discountLimit: (discountLimit: number) => `最高减 JPY${discountLimit}`,
    minSettlementAmountRemark: (minSettleMent: number) =>
      `优惠前不低于${commaedInteger(
        minSettleMent
      )} 日元的订单可使用。※如支付金额不超过5,000日元，由于不满足免税条件将无法购买。`,
    noCouponToUse: `没有可使用的优惠券`,
    noMedsAlcohol: `医药品、酒类饮品不适用此优惠。`,
    notLogin: `登录后即可兑换优惠券`,
    notUseCoupon: `不使用优惠券`,
    note: `注意事项`,
    pickCoupon: `选择优惠券`,
    pleaseReview: `无法使用此优惠券。请确认优惠券的使用条件。`,
    terms: `使用条件`,
    usableBeforeJst: `(日本时间) 前有效`,
    usePromoCode: `输入优惠码`,
    discount: {
      limit: (amount: number) => `使用此优惠券最高可省${amount}日元。`
    },
    list: {
      pleaseLogin: `领取优惠券请先登录账号。`,
      title: `优惠券一览`,
      page: {
        description: `日本全国各地特产、日本旅行伴手礼轻松、超值购，就上玩尽日本线上免税店！`,
        title: `玩尽日本优惠券｜玩尽日本购物`
      }
    }
  },
  creditCard: {
    error: {
      identityAuthentication: `信用卡的支付认证失败`,
      useAnotherCard: `请使用其他信用卡`
    }
  },
  crossSelling: {
    activity: {
      title: `东京的人气体验活动行程`
    },
    tickets: {
      title: `前往东京的交通方式&超值车票`
    }
  },
  customerSupport: {
    chat: `线上聊天咨询`,
    description: `常见问题。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
    title: `客户服务`
  },
  discountNotice: {
    addToCart: (rate: number) => `已应用${rate}折优惠并加入购物车`,
    description: `加入购物车后自动应用优惠。\n可与其他优惠券叠加使用。`,
    mainText: (className: string, rate: number) => `此商品<span class=${className}>可享${rate}折优惠</span>`
  },
  favorites: {
    addSelectedToCart: `将选择的商品加入购物车`,
    addToFavorite: `加入我的最爱`,
    addedToFavorite: `已加入我的最爱`,
    isEmpty: `没有收藏喜爱的商品`,
    notLogin: `请登陆后\n查看您收藏的商品。`,
    removeSelectedFromFav: `将选择的商品从我的最爱中删除`,
    title: `我的最爱`
  },
  featured: {
    featuredCollections: `特集一览`,
    keywords: `热门关键词`,
    moreFeaturedCollections: `查看更多特集一览`,
    popularCosmeticSets: `玩尽日本限定 热销化妆品精选套装`,
    recommendedFeaturedCollections: `推荐特集`,
    recommendedProducts: (largeCategoryName: string) => `热门${largeCategoryName}推荐`,
    shiseidoBestHit2023: `资生堂畅销产品2023`,
    antiUVCosmeticsLP: {
      description: `「人气化妆品哪里买？」以免税价格订购最新防晒好物！「安耐晒」「CPB肌肤之钥」「POLA宝丽」「SK-II」等热门品牌一应俱全。由玩尽日本买手带来当下力推的化妆品。`,
      title: `日本必买！防晒化妆品特辑`,
      addToCartNow: {
        title: `立刻加入购物车`
      },
      buyerComment: {
        title: `买手评价`
      },
      buyerRecommendation: {
        comment: `在接下来的季节，CPB护肤套装可以保护肌肤免受紫外线和干燥等外部压力侵害，令肌肤焕发光彩。\n集全球顶尖技术于一身的CPB，备受用户赞誉的超人气品牌。`,
        title: `玩尽日本买手推荐！\n夏季护肤套装`,
        product: {
          content: `CPB肌肤之钥 光彩赋活精华水 湿润型 170 ml\n光采赋活日间防护乳 125 ml\nCPB肌肤之钥 晶致赋活精华露 50 ml`,
          title: `【5%OFF】CPB肌肤之钥夏日套装`
        }
      },
      contentDesc: {
        setTitle: `套装内容`,
        title: `特点`
      },
      featuredCosmeticPrimer: {
        comment: `从防晒到底妆，两个流程一步解决。打造自然美肤。`,
        title: `2024年备受瞩目的底妆`,
        product: {
          content: `UV-tinted cream that provides sun protection, a tone-up effect, and color correction. \nIt is a non-chemical formula with the highest level of UV protection in Japan.`,
          title: `THREE スムースオペレーターハイパフォーマンスクリーム 01`
        }
      },
      featuredSunscreen: {
        comment: `不想晒黑？就选安耐晒小金管！\n乳液型防晒霜，但肤感清爽且延展性强，\n不会有防晒霜特有的厚重感。\n还能作为底霜，适合日常使用\n防水效果好，适合运动和休闲活动！卸妆时只需肥皂一洗就掉。`,
        title: `防紫外线的基础措施！\n2024年备受瞩目的防晒用品`,
        product: {
          content: `长久保湿\n防水\n使用香皂即可卸除\n花香`,
          title: `ANESSA`
        }
      },
      recommendationRate: {
        title: `推荐度`
      },
      sale: {
        setTitle: `套装特惠价`,
        title: `特價`
      },
      saleText: {
        title: (currency: string, preDiscountPrice: number, discountAmount: number, className: string) =>
          `原价${currency}<span class=${className}>${preDiscountPrice}</span>（含税），现在购买立减${currency}<span class=${className}>${discountAmount}</span>`
      }
    },
    anti_aging: {
      short_desc: `适合抗衰老、皱纹的人气护肤、化妆品`,
      title: `抗衰老・细纹`
    },
    beautyAppliances: {
      subTitle: `日本制美容家电＆美容用品，犒劳辛勤的自己！`,
      title: `最先进美容家电＆美容用品`
    },
    buyersChoiceFood: {
      subTitle: `对日本了如指掌的玩尽日本买手精选推荐好物。`,
      title: `买手精选（食品）`
    },
    coldSake: {
      subTitle: `炎天暑月就想来上一杯，冰镇后更美味的日本清酒！`,
      title: `推荐冷酒`
    },
    collagen: {
      short_desc: `添加人气美容成份──胶原蛋白，日本品牌的护肤品、化妆品、营养补充品`,
      title: `胶原蛋白专栏`
    },
    drug: {
      adBanner: {
        title: `日本必买 非处方药物`
      }
    },
    drug_store: {
      short_desc: `在日本药妆店必买的化妆品及零食`,
      title: `日本药妆店化妆品`
    },
    facialCleansers: {
      subTitle: `甄选推荐每次洗脸都倍感清爽的洗面奶。`,
      title: `日本人气洗面奶`
    },
    gift: {
      subTitle: `买日本特色伴手礼，就上玩尽日本！`,
      title: `送礼首选，日本伴手礼特集`
    },
    index: {
      meta: {
        description: `特惠商品与各季精选商品一览。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`
      }
    },
    japaneseTraditionalSweetAndSnacks: {
      subTitle: `日本全国人气和果子大集合！`,
      title: `日本传统和果子`
    },
    limitedSale: {
      caveat: `目前商品正准备上架，请稍作等待！`,
      expirationConfirm: `■购买前请确认商品说明。`,
      expirationDate: (year: string, month: string, day: string, className: string) =>
        `请注意，本商品有指定取货日期。<span class=${className}>「${year}/${month}/${day}」之后将不再销售</span>，因此取货日需在上述日期之前。`,
      title: `限时促销`
    },
    lotion: {
      bestLotionsToBuyInJapan: `日本必买化妆水`,
      description: `完美行小编推荐化妆水  | 通过玩尽日本购物买日本纪念品，来日本旅行时即可在机场领取已购买的商品。来日本旅行时随时可以购买各种纪念品，购买更优惠、更轻松，请选择WAmazing线上免税店！`,
      leadSentence: `间隔已久的日本旅行，而且还是超低汇率的好时机,现在不购物还等什么呢！\n这次由完美行小编介绍下「送礼最佳护肤商品 ～化妆水篇～」。这次由小编推荐各自觉得好用的最基本的化妆水。不管是给亲朋好友送礼，还是自用都非常推荐，快来看看吧!\n其中包含了日本限定商品，千万别错过哦！\n※以下为个人观点`,
      otherLotions: `其他人气化妆水推荐`,
      wamazingEditorChoice: `玩尽日本小编推荐`,
      elixir: {
        description: `此商品尚未在日本以外的国家发售，绝对不能错过！包装比原来精简，想必能受到20~40岁的广大用户喜爱。浓稠度在系列商品中位居第一，带有治愈花香。`,
        title: (className: string) =>
          `2022年9月全新包装！<span class=${className}>「怡丽丝尔纯肌净白晶润水（ 滋润型）」</span>`
      },
      haku: {
        description: `想要美白的集美们一定不能错过。质地浓稠肤感却很清爽保湿，且富含美白成分。淡淡的清香也非常吸引人。`,
        title: (className: string) => `美白化妆水首推<span class=${className}>「HAKU」</span>`
      },
      obagi: {
        description: `送给家中年长者首选！在日本也拥有很高的的抗老口碑。保湿力强，质地浓厚但很好吸收。带有让令人神清气爽的柑橘香。高価格アイテムなので、円安の今が特にお得です！`,
        title: (className: string) => `高保湿力\n<span class=${className}>「Obagi X」</span>`
      },
      orbis: {
        description: `ORBIS品牌下超人气的「ORBIS U」在日本全新改版推出。该商品仅限日本地区出售，拿来送礼准没错！\n质地浓稠的化妆水能充分保湿，改良过的瓶身有三角切口，为整体时尚加分。`,
        title: (className: string) => `日本限定版\n<span class=${className}>「ORBIS U」</span>`
      }
    },
    meta: {
      common: {
        description: `购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`
      }
    },
    mtFuji: {
      subTitle: `经典日本伴手礼！可爱的富士山周边商品大集合！`,
      title: `富士山商品特辑`
    },
    nibbles: {
      subTitle: `甄选日本佐酒零食`,
      title: `下酒必备！日本佐酒零食`
    },
    pickUp: {
      title: `精选商品`
    },
    quickShip: {
      shopNow: `立即查看`,
      title: `最快送达商品`
    },
    sensitive_skin: {
      short_desc: `敏感肌人士也可以放心使用的人气护肤、化妆品`,
      title: `敏感肌肤专栏`
    },
    serums: {
      subTitle: `网罗日本厂商发售的优质美容精华。`,
      title: `日本高品质美容精华`
    },
    shoppingArticle: {
      title: `有助于购物的信息`
    },
    skin_whiten: {
      short_desc: `人气美白护肤品`,
      title: `美白・淡斑`
    },
    slug: {
      meta: {
        description: `购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`
      }
    },
    summer2023: {
      naviTitle: `2023年夏季推荐商品`
    },
    summerTreats: {
      subTitle: `炎炎夏日，尽享美味！冰镇更可口的夏日甜点特辑。`,
      title: `冰冰凉的消暑夏日甜点`
    },
    sunBlockRecommendation: {
      subTitle: `今天也做好紫外线防护了吗？完美防晒！做好防晒从现在开始！`,
      title: `2024年防晒护肤特辑`
    }
  },
  featuredCollections: {
    allShow: `查看全部特集`
  },
  footer: {
    genuineDescription: `所有商品皆为官方正品。`,
    genuineTitle: `正品认证`,
    safeDescription: `提供安全又安心的服务。`,
    safeTitle: `安心・安全`,
    serviceGuide: `服务指南`,
    userAgreement: `会员使用规则`,
    weappDescription1: `立即扫描关注`,
    weappDescription2: `玩尽日本WAmazing`,
    weappTitle: `官方公众号`
  },
  guide: {
    attention1: `确认取货地点\n是否正确`,
    attention2: `确认取货日期`,
    attention3: `携带护照`,
    attention4: `确保手机网络\n可使用`,
    confirmIdentity: (className: string) => `按照储物柜平板指示，进行<span class=${className}>本人身份认证</span>。`,
    confirmLocation: `确认取货地点`,
    confirmPassport: `护照信息确认`,
    confirmQrcode: `确认QR码`,
    description: `玩尽日本购物使用教程。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
    dontForget: `注意事项`,
    enterFourDigitNumber: (className: string) =>
      `在储物柜前，从<span class=${className}>预约详细页面</span>点击<span class=${className}>「输入4位数字」</span>，并输入平板上显示的<span class=${className}>4位数字</span>。`,
    followTabletAndReceive: (className: string) => `按照储物柜平板指示，领取<span class=${className}>商品</span>。`,
    mustBeEPassport: (className: string) => `※必须为<span class=${className}>含有芯片的护照</span>。`,
    note: `※领取商品时，请务必携带含芯片的护照以进行本人身份确认。`,
    openQrcodeAndScanTablet: (className: string) =>
      `在储物柜前，请从<span class=${className}>预约详细页面</span>打开<span class=${className}>「商品领取QR码」</span>，对准储物柜平板镜头进行扫描。`,
    payment: `取货时付款`,
    receive: `领取商品`,
    title: `取货指南`,
    notes: {
      comeInPerson: `为避免取货时的拥堵情况，仅限预购者本人前来办理取货手续，感谢您的理解与配合。`,
      note1: `付款时需要连接网络。请您保持良好的网络环境。`,
      note2: `仅限预购者本人完成购买手续，并确保取货人与预购者身份一致。`,
      note3: `预购时需指定取货地点以及希望取货的日期时间，请确认地点及时间后取货。`,
      note4: `办理购买手续时，需出示预购者本人的护照及上陆许可贴纸。请务必携带本人护照前来取货。另外，只限含有芯片的电子护照。并请在上陆许可贴纸的有效期内取货。`,
      note5: `为完成取货手续，过程中需拍摄预购者本人的面部照片，敬请留意。拍摄面部照片只为确认该护照于本人是否一致，确认后会立刻删除照片。`,
      note6: `为完成取货手续，预购者本人需登录本公司账号并进行付款。如预购者本人使用其他账号登录，将不能付款，敬请留意。`,
      note7: `如不遵守上述任何一项，将不能完成购买手续，敬请留意。`,
      other: `其他`,
      readFollowingNotes: `关于购买及领取商品的手续，请事先确认以下事项。`,
      title: `注意事项`
    },
    page: {
      title: `使用教程`
    }
  },
  index: {
    BeautyEquipmentsRecommendation: {
      subTitle: `超人气，抗衰老、提拉紧致美容仪器。`,
      title: `美容仪器`
    },
    babyProductsRecommendation: {
      subTitle: `奶粉、辅食等婴儿用品大集合！`,
      title: `日本人气婴儿用品`
    },
    dhcRecommendation: {
      subTitle: `维生素、胶原蛋白等人气DHC保健品`,
      title: `DHC保健品`
    },
    healthFoodRecommendation: {
      subTitle: `日本本土的美容・瘦身健康食品，其他地方不容易买到哟。`,
      title: `人气美容食品`
    },
    maskRecommendation: {
      subTitle: `精心呵护，敷出白“肤”美。人气面膜一次屯个够。`,
      title: `面膜敷不停`
    },
    matchaRecommendation: {
      subTitle: `说到日本就不能错过抹茶！\n甄选人气抹茶商品！`,
      title: `人气抹茶伴手礼`
    },
    omiyageRecommendation: {
      subTitle: `超人气点心,拿来送礼最合适！`,
      title: `精选点心礼盒`
    },
    popularRecommendation: {
      subTitle: `日本的口碑好物，种草剁手清单。`,
      title: `种草清单`
    },
    shiseidoBestHit2023: {
      subTitle: `不容错过的日本殿堂级化妆品！`,
      title: `资生堂畅销产品2023`
    },
    snacksRecommendation: {
      subTitle: `日本限定特色点心、宅家追剧好伴侣，超推荐的送礼佳品。`,
      title: `必买点心零食`
    },
    snacksSetRecommendation: {
      subTitle: `必买人气点心套装，省心省力的送礼佳品。`,
      title: `人气套装`
    },
    summer2023Recommendation: {
      subtitle: `2023夏季家庭出游推荐商品特辑`
    }
  },
  issuedCoupon: {
    checkCouponNow: `立即查看优惠券`,
    couponHasBeenIssued: (className: string) =>
      `成功领取优惠券。\n可通过<span class=${className}>购物车页面中的「选择优惠券」</span>查看优惠券。`
  },
  localSouvenirs: {
    area: {
      suffix: `地区`,
      title: (area: string) => `${area}伴手礼`
    },
    aside: {
      left: {
        title: `内容`
      }
    },
    buyerComment: {
      title: {
        full: `本月买手精选`,
        row1: `本月`,
        row2: `买手精选`
      }
    },
    buyerPickUpsByRegion: {
      title: {
        full: `日本全国买手精选`,
        row1: `日本全国买手`,
        row2: `精选`
      }
    },
    buyerRecommendedMaker: {
      title: {
        full: `本月精选品牌`,
        row1: `本月`,
        row2: `精选品牌`
      }
    },
    hokkaidoTohoku: {
      description: `北海道・东北地区广袤的大自然与寒冷的气候孕育出超多美味！北海道由于其发达的农业和畜牧业，土豆和奶制品的零食伴手礼非常有名。而山形和岩手・宫城等县所在的东北地区，有着非常有地域性色彩的传统乡土料理，以及各县不同特色的日本酒。`,
      title: `北海道・东北`
    },
    japan: {
      description1: `日本全国各地伴手礼大集合！`,
      description2: `使用线上免税店「玩尽日本 购物」，可在线购买日本全国伴手礼，并前往机场或车站就能轻松取货！\n快来看看有没有感兴趣的地方特产吧♩`,
      navi: `日本全国伴手礼大集合`,
      title: `日本全国　伴手礼大集合`
    },
    kansaiChushikoku: {
      description: `关西・中四国地区包含大阪・京都・奈良以及濑户内海周围的广岛及四国（香川・愛媛・德岛・高知）等地。濑户内海附近气候宜人海产丰富，使用海鲜以及当地名产柠檬制作的零食伴手礼美味好吃，非常出名！`,
      title: `关西・中四国`
    },
    kantoKoshinetsu: {
      description: `关东甲信越地区有着东京、神奈川等知名观光地，游客众多。所以伴手礼也大多精致美味，非常适合买回家送给亲朋好友！而新潟县是日本屈指可数的大米产地，当地日本酒也非常受到日本人的喜爱。`,
      title: `关东甲信越`
    },
    kyushuOkinawa: {
      description: `九州・冲绳地区包括福冈・熊本・鹿儿岛及冲绳。九州特产明太子打造的零食、蒸馏酒「烧酌」种类非常丰富。而冲绳则有着使用当地生产的黑糖以及食盐制作的零食，还有「金楚糕」等非常有冲绳特色的伴手礼。`,
      title: `九州・冲绳`
    },
    maker: {
      aokiSofuan: {
        description: `大阪青木松风庵创立于1983年，是一家老字号和菓子店。其中名点「月化妆」最受欢迎，现已成为大阪的经典伴手礼。青木松风庵使用精选当地食材，结合传统与创新工艺，打造广受各年龄层喜爱的产品。实体店设计精致高雅，部分门店还有咖啡区。名点「月化妆」主要在关西地区销售。青木松风庵积极协助地区发展，研发使用当地食材的产品，致力于为地域做出贡献。`,
        title: `青木松风庵`
      },
      obusedo: {
        description: `小布施堂是位于长野县小布施町的老字号和菓子店。小布施堂位于著名栗子产地，使用当地优质栗子打造的和菓子非常美味，特别是栗鹿子和栗蒸羊羹最受欢迎。享受美丽街景的同时，品尝季节限定或限定店铺的商品，惬意非凡。店内还设有咖啡馆和餐厅，提供使用当地食材打造的甜点和料理。敬请在此感受创立至今约400年的深厚历史文化以及温馨真挚的款待。`,
        title: `小布施堂`
      }
    },
    page: {
      description: `玩尽日本线上免税店汇集了来自日本全国各地的500多种当地特产，从「超人气经典伴手礼」到「仅在当地才能买到的地区限定商品」应有尽有。提前预购后，在车站或机场轻松取货，无需排队也没有售罄烦恼！敬请关注玩尽日本买手们走遍日本全国精选推出的「当月推荐商品」和「商品人气榜」！了解日本伴手礼最新资讯，畅享旅行之乐。`,
      title: `47个都道府县制霸！玩尽日本独家甄选，必买日本特产日本全国伴手礼大集结！`
    },
    prefecture: {
      aichi: `爱知`,
      akita: `秋田`,
      aomori: `青森`,
      chiba: `千叶`,
      ehime: `爱媛`,
      fukui: `福井`,
      fukuoka: `福冈`,
      fukushima: `福岛`,
      gifu: `岐阜`,
      gunma: `群马`,
      hiroshima: `广岛`,
      hokkaido: `北海道`,
      hyogo: `兵库`,
      ibaraki: `茨城`,
      ishikawa: `石川`,
      iwate: `岩手`,
      kagawa: `香川`,
      kagoshima: `鹿儿岛`,
      kanagawa: `神奈川`,
      kochi: `高知`,
      kumamoto: `熊本`,
      kyoto: `京都`,
      mie: `三重`,
      miyagi: `宫城`,
      miyazaki: `宫崎`,
      nagano: `长野`,
      nagasaki: `长崎`,
      nara: `奈良`,
      niigata: `新潟`,
      oita: `大分`,
      okayama: `冈山`,
      okinawa: `冲绳`,
      osaka: `大阪`,
      saga: `佐贺`,
      saitama: `埼玉`,
      shiga: `滋贺`,
      shimane: `岛根`,
      shizuoka: `静冈`,
      tochigi: `栃木`,
      tokushima: `德岛`,
      tokyo: `东京`,
      tottori: `鸟取`,
      toyama: `富山`,
      wakayama: `和歌山`,
      yamagata: `山形`,
      yamaguchi: `山口`,
      yamanashi: `山梨`
    },
    region: {
      chugoku: `中国`,
      hokkaido: `北海道`,
      hokuriku: `北陆`,
      kansai: `关西`,
      kanto: `关东`,
      kyushu: `九州`,
      okinawa: `冲绳`,
      shikoku: `四国`,
      tohoku: `东北`,
      tokai: `东海`,
      airport: {
        chugoku: `广岛机场`,
        hokkaido: `新千岁机场`,
        hokuriku: `null`,
        kansai: `JR关西机场站`,
        kanto: `JR成田机场站\nJR成田第二大楼站\n羽田机场T3站`,
        kyushu: `天神巴士总站\nJR博多站`,
        okinawa: `那霸机场`,
        shikoku: `null`,
        tohoku: `仙台机场`,
        tokai: `中部国际机场`
      },
      description: {
        chugoku: `日本的中国地区因温暖的气候孕育了多样的食材和特色美食，无论是广岛的御好烧和尾道拉面，还是冈山的白桃和麝香葡萄都是一绝。此外，岛根的出云荞麦面和山口的河豚刺身也是当地的招牌美食。还有广岛的枫红叶馒头、冈山的吉备团子等各色甜点。新鲜的海鲜和肥沃土地孕育的农产品构成了此处独特的饮食文化，深深俘获着游客们的心。`,
        hokkaido: `北海道以其壮丽的自然景观和自然孕育的美味佳肴，深受世界各地游客喜爱。这里的农畜产品、乳制品、海鲜、酒类都新鲜且品质上乘，长久以来被誉为「美食宝库」。尤其是蔬果、风味浓郁的乳制品、新鲜的海鲜享负盛名，日本清酒和啤酒也因独特的地方风味而广受喜爱。\n\n\n\n`,
        hokuriku: `北陆地区以种类丰富的新鲜海鲜著称，尤其是富山的萤火鱿、福井的越前蟹、石川的喉黑鱼等高级海产，是北陆地区一直深受喜爱的特产。此外，因当地水质优异，日本清酒也非常有名。北陆地区酿酒的历史悠久，以讲究的工艺酿造的日本清酒，口感顺滑和香气醇厚。北陆地区也有各色当地和菓子。金泽的金箔和菓子豪华精致，福井的羽二重饼也很受欢迎。`,
        kansai: `关西拥有深厚的历史底蕴和文化背景，对其饮食文化也影响深远。特别是以京都为中心发展的「抹茶」，伴随着茶道文化诞生了许多美味的甜点。从抹茶和菓子到西式甜点，种类繁多，可在感受古都风情的同时，享受美食。这种文化交融也是关西饮食文化的一大魅力。\n此外，京都的伏见和兵库的灘地区，因清澈的水源和优质的大米，自古以来便是高品质日本清酒的出产地，如今也是远近驰名。`,
        kanto: `在关东地区可尽情品尝江户前寿司、天妇罗、荞麦面等江户前料理。此外，东京的筑地市场、丰洲市场等大型鱼市，全国各地的新鲜鱼类汇集于此，新鲜海鲜取之不尽。作为多元化的城市，东京不仅有各色新颖的甜点、伴手礼，还有许多老字号和菓子店，特别是银座、浅草等地区，可以尽情享受传统的美味。`,
        kyushu: `九州也是拥有丰富特色美食的美食宝库。福冈的博多拉面、大分的鸡肉天妇罗、鹿儿岛的黑猪肉都极具人气。同时这里也有各色水果甜点，如福冈的「甘王草莓」、长崎的「长崎蛋糕」在全国都享有盛名。而九州自古以来就是著名的烧酌产地，如今也成为当地酒类的代表！`,
        okinawa: `\n冲绳得天独厚的自然环境和独有的文化，也造就了当地独特的饮食文化。如什锦炒苦瓜、花生豆腐、冲绳排骨面等，皆使用当地食材，堪称绝品。伴手礼也种类繁多，其中使用岛辣椒制作的零食、紫薯塔和金楚糕最具人气！此外，冲绳还是泡盛酒的著名产地，其独特的风味广受欢迎。`,
        shikoku: `四国地区以丰饶的大自然以及其温暖的气候孕育出的食材闻名遐迩。高知的炙烤鲣鱼、爱媛的新鲜鲷鱼料理、香川的赞岐乌冬面以及德岛的阿波尾鸡等，每个地方都有独具特色的美食可以品尝。此外，这里还盛产蜜柑、酢橘等柑橘类水果，具有新鲜浓郁的风味。各个地区的美食文化也体现了当地的风土人情，这正是四国独具一格的魅力所在。`,
        tohoku: `日本的东北地区以美味的海鲜、大米和发酵食品而闻名。可品尝到新鲜的牡蛎、扇贝，以及「烤米棒锅」「碗子荞麦面」等传统的乡土料理。此外，东北地方也是日本著名的日本清酒产地，拥有诸多当地美酒。又因坐拥富饶的自然资源，还是樱桃和苹果的著名产地。`,
        tokai: `东海地区的美食魅力丰富多彩。如名古屋的极品「味噌猪排」、香喷喷的「鳗鱼饭」，以及静冈独具特色的「关东煮」等，各地特产汇集于此成就了极致美食。其中又以名古屋独特的饮食文化脱颖而出，不断涌现出像「小仓红豆吐司」这样的热门产品。造访东海地区时，不妨尝尝这些丰富多彩的美食呀！`
      },
      label: {
        chugoku: `中国・四国`,
        hokkaido: `北海道・东北`,
        hokuriku: `东海・北陆`,
        kansai: `关西`,
        kanto: `关东`,
        kyushu: `九州・冲绳`,
        okinawa: `九州・冲绳`,
        shikoku: `中国・四国`,
        tohoku: `北海道・东北`,
        tokai: `东海・北陆`
      }
    },
    relatedArticles: {
      title: {
        full: `伴手礼相关推荐文章`,
        row1: `伴手礼相关`,
        row2: `推荐文章`
      }
    },
    souvenirRanking: {
      title: {
        full: `日本全国伴手礼排行榜`,
        row1: `日本全国`,
        row2: `伴手礼排行榜`
      }
    },
    tokaiHokuriku: {
      description: `东海・北陆地区包括名古屋所在的爱知县、静冈县、保留着浓厚日本文化色彩的石川县（金泽市）以及富山・福井等地。尤其有着严寒的气候及丰富水资源的北陆地区，造就了得天独厚的日本酒生产环境，让当地日本酒的风味别具一格！`,
      title: `东海・北陆`
    }
  },
  lp: {
    mediaCoupon: {
      goToTop: `返回首页`,
      goToWAmazing: `前往玩尽日本线上免税店`,
      faq: {
        a1: `非常抱歉，已成立的订单不可以变更取货日期。如要变更请先取消订单再重新下单。`,
        a2: `医药类商品（供应商：SUGI杉药局）无法免税。且仅购买医药品时，总金额需满3,000日元。`,
        a3: `十分抱歉，没有IC芯片的护照无法取货。`,
        a4: `根据法律规定，非护照持有者本人无法办理免税手续，请护照持有者本人取货。`,
        label: `常见问题`,
        q1: `可以变更取货日期吗?`,
        q2: `医药品也可以免税吗？`,
        q3: `没有IC芯片的护照可以取货吗？`,
        q4: `不是护照持有者本人也可以取货吗？`,
        q5: `有哪些付款方式？`,
        a5: {
          aftee: `AFTEE先享后付`,
          detail1: `支持信用卡付款。可使用VISA、Mastercard、JCB、American Express信用卡。`,
          detail2: `※使用微信付款的用户请注意，在取货或支付尾款时也必须使用微信支付。`,
          detail3: `※也可于超市、ATM付款，或使用电子钱包（AFTEE pay now）。`
        }
      },
      footer: {
        app: `点此下载APP`,
        enjoy: `玩转日本之旅，尽享精彩人生！`,
        wamazing: `玩尽日本 购物`
      },
      hero: {
        subtext1: `日本人气伴手礼`,
        subtext2: `在线`,
        subtext3: `机场`,
        subtitle: `无需在免税柜台排队！`,
        text1: `种类繁多`,
        text2: `预约`,
        text3: `取货`,
        title: `使用线上免税店\n轻松享受\n旅行与购物`
      },
      how: {
        goToTop: `使用优惠券购物`,
        label: `优惠券使用方法`,
        labelWithPrice: (price: string) => `${price}日元优惠券的使用方法`,
        labelWithRate: (rate: number) => `${formatDigits(100 * rate)}%优惠券的使用方法`,
        list1: `于优惠券页面领取`,
        list1Click: `点击以下领取优惠券`,
        list2: `将商品添加至购物车`,
        list3: `确认购物车`,
        list4: `点击购物车页面「详细金额」下的「选择优惠券」`,
        list5: `粘贴步骤1中复制的代码，点击「OK」`,
        list6: `勾选显示出的优惠券并点击「选择」`,
        list7: `优惠券添加完成！`,
        notice1: `※<strong>消费金额满5,000日元即可享受免税优惠</strong>，购物时请务必认准<strong>「供应商」</strong>标识。此外是否可使用优惠券因各使用条件而异，敬请谅解。`
      },
      introduction: {
        feature1: `旅行前下单`,
        feature2: `机场取货`,
        feature3: `自助办理免税手续`,
        forWamazing: `使用「玩尽日本 购物」\n<em>提前购买商品</em>，\n<em>于日本机场</em>\n<em>轻松取货</em>。`,
        introText: `全新线上免税店购物方式`
      },
      notice: {
        label: `重要须知`,
        notice1: {
          text1: `部分商品热卖商品可能缺货。`,
          text2: `因生产商供应情况，售罄商品的补货可能需较长时间。\n`,
          text3: `敬请谅解。`
        },
        notice2: {
          text1: `如果有心仪商品，`,
          text2: `请尽快下单。`
        }
      },
      problem: {
        list1: `旅行中还要<em>拖着行李太难了</em>`,
        list2: `又要看孩子又要<em>看行李太难了</em>`,
        list3: `在电车里、路上<em>差点撞到其他人</em>`,
        list4: `储物柜<em>总是没有空位</em>`,
        list5: `<em>不停寻找</em>出售心仪产品的<em>商店好心累</em>`,
        list6: `旅游回程在机场选伴手礼<em>慌手忙脚...</em>`,
        list7: `时间有限，<em>无法充分享受购物乐趣</em>`,
        list8: `伴手礼的<em>价格超出预期</em>`,
        more: `想在旅游中玩得更尽兴`,
        note1: `解决旅游中遇到的难题`,
        note2: `打造难忘的日本之旅`,
        strong: `又有着这样那样的烦恼？`,
        point: {
          subject: `玩尽日本 购物`,
          subtext1: `选购时间`,
          subtext2: `多拍美照`,
          subtext3: `免税购物`,
          text1: `大大节省`,
          text2: `解放双手`,
          text3: `优惠多多`
        }
      },
      safety: {
        label: `「玩尽日本 购物」`,
        subtitle: `本公司出售的所有产品均为原装正品。`,
        title: `关于正品`,
        list1: {
          text: `均在SUGI杉药局的指导下销售。`,
          title: `关于医药品`
        },
        list2: {
          text: `致力于保护客人的隐私和数据安全。`,
          title: `个人信息管理`
        }
      },
      showProducts: {
        add: `热门商品不断上新！`,
        find1: `在线购物`,
        find2: `轻松找到心仪商品`,
        label: `节省寻找商品的时间`,
        title1: `上架商品<em>超过10,000种！</em>`,
        title2: `网罗日本全国各地的商品`
      },
      unique: {
        label: `和在机场购物有什么不同`,
        list1: {
          text: `不必再在拥挤的免税柜台排队等候。`,
          title: `无需在免税柜台大排长龙`,
          type: `无需\n排队`
        },
        list2: {
          text: `部分产品价格可能包含<em>免税手续费</em>。`,
          title: `不含手续费`,
          type: `手续费`
        },
        list3: {
          text: `各色日本特色好物琳琅满目`,
          title: `商品种类繁多`,
          type: `极具日本特色`
        },
        list4: {
          text: `化妆品、零食、医药品、动漫周边等各类商品。`,
          title: `丰富的在线商品`,
          type: `甚至还有\n动漫周边`
        }
      },
      userGuide: {
        label: `不再错过按下快门的机会`,
        subtitle: `「解放双手轻松游」`,
        title: `不再提着大包小包逛街`,
        guide: {
          icon1: `巴士总站`,
          map1: `<em>全国共11处</em>取货点！\n主要城市机场车站均设有取货柜`,
          multi: `支持多种语言，享受安心便捷的服务`,
          step1: `可在旅游<em>3个月前</em>～取货<em>3天前</em>下单！\n下单时请指定取货机场。`,
          step2: `凭<em>护照</em>和<em>入国许可证</em>即可轻松取货。`,
          step3: `提取商品，踏上回国之行。\n或者继续享受旅行。`,
          support: `使用取货柜时如遇到问题\n请<em>扫描二维码</em>联系客服`,
          text: `「玩尽日本 购物」使用指南`,
          threeMins: `取货时间 约3分钟`,
          title: `从下单到取货仅需3步`
        }
      },
      voice: {
        label: `用户反馈`,
        list1: `一次性买齐不同品牌、不同商家的零食，满足免税条件无困难。商品种类也很丰富。`,
        list2: `到日本后很难抽出时间购物，所以就先在「玩尽日本 购物」下单了。感觉非常方便。`,
        list3: `看到「不用再提着大包小包」这句话时，简直深得我心。`,
        list4: `非常感谢客服尽力协助解决问题。以后有机会还会再次使用玩尽日本相关服务。`
      }
    },
    serviceIntroduction: {
      returnToSnow: `TODO: lp.serviceIntroduction.returnToSnow@zh_cn`,
      snowHero: {
        title: `TODO: lp.serviceIntroduction.snowHero.title@zh_cn`
      },
      snowProblem: {
        list1: `TODO: lp.serviceIntroduction.snowProblem.list1@zh_cn`,
        list2: `TODO: lp.serviceIntroduction.snowProblem.list2@zh_cn`,
        list3: `TODO: lp.serviceIntroduction.snowProblem.list3@zh_cn`,
        more: `TODO: lp.serviceIntroduction.snowProblem.more@zh_cn`,
        note: `TODO: lp.serviceIntroduction.snowProblem.note@zh_cn`,
        strong: `TODO: lp.serviceIntroduction.snowProblem.strong@zh_cn`
      }
    }
  },
  lunarNewYearSale: {
    drugDiscount: (className: string) => `全场<span class=${className}>8</span>折`,
    metaDescription: `【免税10%➕最高25折】春节限定超值优惠！`,
    metaTitle: `玩尽日本春节大促来啦`
  },
  maker: {
    maker: `生产厂家`
  },
  mypage: {
    title: `我的页面`
  },
  nativeApp: {
    badge: {
      exclusive: `App限定优惠券正在发放中`,
      title: (pink: string) => ` <span class=${pink}>App限定优惠券正在发放中</span>\nAPP4.7分好评/超过3,500条`,
      download: {
        count: {
          currentDate: `截至2024年9月5日`,
          text: `累计下载次数突破30万次`
        }
      },
      rating: {
        title: `APP4.7分好评/3,557条`
      }
    }
  },
  orderForm: {
    addNewCard: `新增信用卡`,
    andConfirmedInput: `并确认信息填写无误`,
    checkNotes: `请确认注意事项`,
    creditCard: `信用卡`,
    creditCardInformation: `支付方式`,
    dateOfBirth: `出生日期`,
    dateOfLanding: `入境日期`,
    fillDateOfBirthAsPassport: `请务必填写护照上的「出生年月日」。`,
    firstName: `护照上的大写名字 (英文)`,
    iAgree: `我同意`,
    lastName: `护照上的大写姓氏 (英文字母)`,
    nameAndDateOfBirth: `姓名和出生日期`,
    notPurchaseWithoutDateOfBirthAsPassport: `若护照上没有「出生年月日」，恕无法购买免税商品。`,
    orderPlaced: `订单完成`,
    passport: `护照`,
    passportInformation: `护照信息`,
    personalInformation: `个人信息`,
    pickupContent1: `※日本停留期间内均可设置取货时间。`,
    pickupDate: `取货日期`,
    pickupIdentity: `个人信息`,
    pickupIdentitySub: `您的个人信息仅用于免税服务`,
    pickupSchedule: `取货日程`,
    pickupTime: `取货时间（需先选择取货日期）`,
    statusOfResidence: `在留资格`,
    supportedCreditCards: `可以利用的信用卡品牌`,
    taxFreeProcedures: `免税手续`,
    userAgreement: `购买条款`,
    validatorMessage: {
      invalidCreditCardType: `请使用VISA, Mastercard, JCB 或 American Express。`,
      mustBeAlphaNum: (field: string) => `请以英文字母或数字输入${field}`,
      mustBeAlphaNumSymbols: (field: string) => `请以英文字母，数字，破折号或下划线输入${field}`,
      mustBeAlphabets: (field: string) => `请以英文字母输入${field}`,
      mustBeNum: (field: string) => `${field}请输入半角数字`,
      mustBeOver20: `日本法律禁止向未满20岁的顾客销售酒类。`,
      mustNotBeEmpty: (field: string) => `请输入${field}`,
      mustSelectCorrectValue: `请输入正确的国家码`
    }
  },
  orders: {
    actuallyPickedAt: `实际取货时间`,
    areYouSureToCancelOrder: `真的要取消订单吗？`,
    autoCancelled: `自动取消`,
    autoCancelledAndCollected: (date: string, className: string) =>
      `由于已超过取货截止时间<span class=${className}>${date}</span>，订单已被取消，商品也已退回。`,
    awaitingNextUse: `期待您再次光临`,
    canBePickedUpUponArrival: `※可在入境时领取`,
    cancelOrder: `取消订单`,
    cancellationFee: `取消费用`,
    cancellationFeeWillBeChargedAfter: (date: string) =>
      `若在${date} (日本时间)后取消订单，将扣除您支付的费用作为取消费用。`,
    cancelled: `已取消`,
    cancelledAt: `取消时间`,
    cancelledByCustomer: `已根据您的要求，\n成功取消订单`,
    checkReceiveMethod: `确认取货方法`,
    checkReceivePlace: `确认取货地点`,
    checkVjwReg: `确认VJW注册方法`,
    confirmPickupMethod: `确认取货点地图及取货方法`,
    createOrder: `创建订单`,
    deadline: `取货截止时间`,
    depositAmount: (field: number) => `定金为${field}日元。`,
    earliestCollectionDate: `最快可取货时间`,
    earliestNotice: `※根据商品不同，发货程序和发货时间等也会有所不同。`,
    firstPaid: `预约完成`,
    goOrderDetailOfSmartPhone: `請透過手提電話的服務畫面，確認取貨用的QR Code，並輸入支付餘額的所需編碼。`,
    infoForPickUp: `取货时所需信息`,
    noCancellationFeeCharged: `无需取消费用`,
    note1: `※1 在免税手续完成之前，我们将收取商品含税价格的20%作为预付款。`,
    note2: `※2 预付款在最终支付时将充当商品金额。`,
    note3: `※3 课税商品无需预约，将直接支付商品金额。`,
    openLocker1: `请确认储物柜编号，`,
    openLocker2: (className: string) => `<span class=${className}>再领取货物。</span>`,
    order: `订单`,
    orderCancelled: `已取消订单。`,
    orderId: `订单ID`,
    orderPlaced: `下单成功`,
    orderPlacedAt: `订单创建于`,
    orderTitle: `预定详情`,
    payAtCounter: (amount: number, className: string) =>
      `的付款余额为<span class=${className}>JPY${commaedInteger(amount)}</span>日元。`,
    payRemainingAmount: `请于取货时支付余额。`,
    paymentProcedure: `输入4位数字`,
    pickupCompleted: `取货已完成`,
    pickupLocation: `取货点在`,
    pleasePickUpBeforeDeadline: (date: string) =>
      `请在日本时间${date}之前取走您的商品。\n若在截止时间前未取货，订单将被取消，商品也将被退回，敬请注意。`,
    qrcodeForPickUp: `查看取货用QR码`,
    requireInternetEnv: `※取货时请确保手机有可使用网络`,
    retrievalProblems: `取货失败时，请点此处`,
    scanQrOnDevice: `请在取货地点出示此二维码`,
    secondPaid: `付款完成。`,
    showQrcode: `请使用出货柜镜头扫描QR码`,
    startReceive: `开始取货`,
    thankYouForShopping: `感谢您的惠顾。`,
    thankYouMessage: `感谢您的使用`,
    vjwRegistered: `是的，已注册VJW`,
    cancelPolicy: {
      Charge20: `总支付金额的20%`,
      freeCancellation: `免费取消`,
      note1: `未发货：无需取消费用`,
      note2: `已发货：预付款的100%（相当于商品价格的20%（含税））`,
      note3: `未取消也未提货：预购手续费的100%（相当于商品价格的20%（含税））`,
      note4: `未取消也未提货：预付款的100%（相当于商品价格的20%（含税））`,
      note5: `由于用户自身原因取消订单而产生上述取消费，将收取预付款作为取消费。`,
      note6: `若产生取消费的订单中包含课税商品，将退还课税商品总额的80%，并将剩余金额作为取消费。`,
      title: `取消政策`
    },
    haneda_shop: {
      noteForPickupLocation: (url: string, className: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${className}>羽田机场的取货地点</a>位于“单轨电车检票闸机内”。 `,
      noteForUsersWithoutJr: (className?: string) =>
        `※乘坐单轨电车以外的交通工具前来的顾客需要另行<span class=${className}>购买车票</span>进入车站。`
    },
    kansai_shop: {
      noteForPickupLocation: (url: string, className: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${className}>关西机场的取货地点</a>位于“JR关西机场站”内。 `,
      noteForUsersWithoutJr: (className?: string) =>
        `※乘坐JR线以外的交通工具前来的顾客需要另<span class=${className}>行购买车</span>票进入车站。`
    },
    locker: {
      enter4number: `请输入储物柜平板上显示的4位数字。`,
      next: `下一步`,
      payAll: (amount: number, className: string) =>
        `付款余额为<span class=${className}>JPY${commaedInteger(amount)}</span>日元。`,
      payRemainingAmount: `支付余额`,
      paymentDetail: `付款详情`
    },
    narita1_shop: {
      noteForPickupLocation: (url: string, linkClassName: string, boldClassName: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${linkClassName}>成田机场的取货地点</a>位于“JR成田机场站电车检票闸机内”。 乘坐JR电车以外的交通工具前来的顾客需要另行<span class=${boldClassName}>购买车票</span>进入车站。`
    },
    narita2_shop: {
      noteForPickupLocation: (url: string, linkClassName: string, boldClassName: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${linkClassName}>成田机场第二航站楼的取货地点</a>位于“JR成田机场第二航站楼检票闸机内”。 乘坐JR电车以外的交通工具前来的顾客需要另行<span class=${boldClassName}>购买车票</span>进入车站。`
    },
    pickupItems: {
      note1: `只有预购者本人可以办理购买及取货手续`,
      note2: `取货时需要出示预购者本人的护照，并只限含有芯片的电子护照。`,
      note3: `办理购买及取货手续时需要连接网络，请您事先准备。`,
      title: `关于领取商品`
    }
  },
  orderstep: {
    step1: `网上购物`,
    step2: `支付\n预付款`,
    step3: `取货地付款\n领取商品`,
    title: `使用流程`
  },
  payment: {
    cardValidUntil: `有效日期`,
    creditCardHolder: `持卡人`,
    creditCardNumber: `信用卡号码`,
    errorRegisteringCreditCard: `未能登錄信用卡`
  },
  pickupSupport: {
    cancel: `取消此次订单`,
    cancellationFeeMayBeAdded: `需自行负担取消订单的费用。`,
    chooseOverseasShippingOrCancellation: `选择海外邮寄或取消订单`,
    consumptionTaxMayBeAdded: `由于海外邮寄商品不属免税范围，或需另外支付消费税。`,
    contactUs: `咨询`,
    deliver: `邮寄服务，省心省力`,
    deliverOrCancel: `申请邮寄或取消订单`,
    deliverOverseasOrCancel: `可申请海外邮寄或取消订单。`,
    flow: `手续流程`,
    note: `※亦可于回国后办理`,
    overseasShippingCostsMayBeAdded: `需自行负担海外邮寄的运费。`,
    pressTheButton: `点击咨询键开始咨询`,
    scanQrCode: `扫描二维码`,
    sendARequest: `填写咨询表格申请受理`,
    sendTheProblem: `将所遇问题发至咨询聊天窗口`,
    title: `安心帮助服务`,
    waitForCustomerSupport: `等待客服联络`
  },
  popularBrand: {
    title: `人气品牌`
  },
  product: {
    shopping: `购物`
  },
  products: {
    FromPickUpDate: (year: string, month: string, day: string, hour: string, minute: string) =>
      `${year}年${month}月${day}日${hour}:${minute}起`,
    alsoSearched: `购买此商品的顾客也查看过这些商品`,
    amountPaidAtReservation: `预约时所支付的金额`,
    amountPaidUponPickup: `领取商品时所需支付的金额`,
    bestBefore: `赏味/使用期限`,
    bestBeforeDate: `最佳品尝期`,
    bookingFee: `预付款`,
    bookingFeeOfVendor: (vendor: string) => `${vendor}的预付款※1,2`,
    brand: `品牌`,
    buyerComment: `买手评价`,
    customersAlsoSearched: `相似商品`,
    desc: `商品说明`,
    details: `明细`,
    fastestDeliveryDate: (year: string, month: string, day: string, hour: string, minute: string) =>
      `最快送达时间 :  ${year}年${month}月${day}日 ${hour}时${minute}分`,
    finalPayment: `取货时支付额`,
    findOutMoreAboutWamazing: `了解完美行购物服务的详细特点`,
    grossWeightGram: `含包装重量`,
    ingredients: `成分/原材料`,
    loginToAddToCart: `请先登录账号方可添加到购物车`,
    maxOrderCountAlert: `購入可能な数に達成しているため、これ以上の注文はできません。ご了承お願いします`,
    minimumBuyPerOrder: (minimum: number) => `每单 ${minimum} 件起购`,
    name: `商品名`,
    netContent: `内容量`,
    note1: `※各商品的订单处理和发货时间有所不同，有些商品可以提前取货。`,
    orderLimitPerOrder: (limit: number) => `每单限购 ${limit} 件`,
    outOfStock: `暂时缺货`,
    pay: `支付`,
    payBookingFee: `去支付`,
    point1: (className: string) => `出行前下单`,
    point2: (className: string) => `在机场取货`,
    point3: (className: string) => `自助型免税`,
    price: `价格`,
    priceOfTaxFreeMerchandise: `免税商品的商品金额`,
    productDescription: (product: string) =>
      `免税${product}。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
    productInfo: `商品信息`,
    productPriceOfVendor: (vendor: string) => `${vendor}的商品金额※3`,
    reason: `特点`,
    sellingPriceTaxFree: `售价(免税)`,
    sellingPriceTaxIncluded: `售价(含税)`,
    shippingDeadline: (year: string, month: string, day: string) =>
      `期间限定特卖品，请在${year}年${month}月${day}日前取货。`,
    shiseido: `资生堂认定网店`,
    showMoreServiceInformation: `查看详细服务说明`,
    size: `尺寸`,
    stockNotification: `补货通知`,
    stockNotificationDesc: `商品补货后将发送电子邮件提醒您。是否设置通知功能？`,
    stockNotificationNotLogin: `设置补货通知请先登录。`,
    stockNotificationRegistered: `已设置完成！`,
    stockNotificationTitle: `是否设置补货通知？`,
    taxFreePrice: `免税价`,
    undiscountedPrice: `原价`,
    waitingReStock: `等待补货`,
    whyBuyFromWAmazing: `WAmazing免税购物的特点`,
    alcohol: {
      ageVerification: `・预约者本人的年龄是否已满20周岁？`,
      airportsWithAlcoholPickupRestrictions: `那霸机场、新千岁机场暂不提供酒类商品的取货服务。`,
      alcoholContent: `酒精度数`,
      confirm: `请确认\n免税条件`,
      howToConfirm: `■确认方法`,
      ingredients: `原料`,
      japaneseLowDesc: `・日本法律规定禁止向未满20周岁的顾客销售酒类商品。`,
      pageDesc: `※由于酒类商品的供应商(东急百货店)不同于其他商品，因此如果同时购买酒类与非酒类商品，两类商品都需要达到5,000日元才可以免税。`,
      passportAgeVerification: `※可能会确认护照上的年龄信息。若发现不满20周岁将取消订单，敬请注意。`,
      polishingRatio: `精米步合`,
      productionArea: `产地`,
      regardingSales: `■关于酒类商品的销售`,
      regardingSalesDesc: (className: string) =>
        `・由于酒类商品的供应商不同于其他商品，因此购买金额无法与其他商品叠加。 \n<span class=${className}>・如同时购买酒类（东急百货店）与非酒类商品，两类商品都需要达到5,000日元。请务必确认商品总额。 </span>\n・酒类商品（东急百货店）的确认方法请参考下图。`,
      reminderForAlcoholImportTaxExemptionLimit: `入境部分国家/地区时所携带的免税酒类有数量限制。请自行提前确认。`,
      storageMethod: `保存方式`,
      taxFreeAlcoholPurchaseThreshold: `因酒类商品的供应商不同，购买酒类商品时需满5000日元以上才可免税`,
      title: `酒类`,
      yesAge20: `是，已满20周岁。`,
      flavor: {
        dry: `辛口`,
        sweet: `甘口`
      }
    },
    buyerCommentLabel: {
      title: `买手精选`,
      patch: {
        text: `买家评价`
      }
    },
    chemicals: {
      confirm: `请仔细阅读注意事项`
    },
    homeAppliance: {
      checkAgreement: `确认家电产品的同意事项`,
      afterSupport: {
        title: `关于产品的售后服务`
      },
      brandSpecificRemarks: {
        title: `其他品牌及产品补充事项`
      },
      contactInfo: {
        desc: `如产品出现任何质量问题，请通过以下咨询窗口联系我们。`,
        details: `本公司恕不受理因用户自身原因提出的退货或退款要求。\n若产品在正常使用情况下出现自然故障，将根据各品牌保修条款提供相应服务。\n对于提供海外保修服务的品牌，在保修期内可协助用户联系居住地附近的品牌客服中心。\n有关各品牌的保修条款，请查看保修书。`,
        title: `咨询窗口`
      },
      returnRefundPolicy: {
        desc: `若商品存在出厂缺陷，原则上可退货及退款。\n请务必在收到商品后的10天内联系上述窗口。超过11天后将无法对出厂不良品进行处理，敬请注意。`,
        mainTexts: `具体出厂缺陷情况也将通过上述窗口确认。届时可能会要求用户提供视频或照片。※若无法提供视频或图片等相关证明，可能无法受理退款或退货。\n退货时的运费由用户承担。\n`,
        title: `关于出厂缺陷的退货退款事宜`
      },
      returnRefundPolicyExtra: {
        desc: `若经本公司确认产品不存在缺陷或故障等问题，恕无法受理退款要求。`,
        mainTexts: `因用户自身原因提出的退货或退款要求也恕不受理。\n如商品已被用户以任何形式进行过加工改造，恕无法受理退货及退款要求。`,
        title: `退货及退款相关补充事项`
      },
      sendBackRepair: {
        desc: `商品到货后第11天起，若发现任何问题并联系售后，可提供「维修服务」。\n在保修期内，将通过「寄修（send back）」（※注）提供免费维修服务。`,
        mainTexts: `视故障状况可能需要付费，敬请知悉。\n请将产品寄回至本公司指定地址，按原厂保修条款进行维修后再寄还给用户。\n商品的退还运费及维修后的回寄运费均由用户承担。\n※注 将发生故障的产品寄至本公司，进行维修等服务后再寄还给用户的服务方式。`,
        title: `因产品故障需要修理时（send back）`
      },
      sendBackRepairExtra: {
        remark: `若经本公司确认未发现存在任何缺陷或故障，恕无法受理`,
        title: `修理相关补充事项`,
        condition: {
          desc: `对于因用户希望维修而寄回的商品，经本公司及原厂确认，未发现存在任何缺陷或故障时，将无法提供维修服务。届时将会重新包装原物并寄还给用户，敬请知悉。（回寄运费原则上由用户承担）\n符合以下任一情况时，即使在保修期内也将收取维修费用。`,
          details: `丢失发票、保修卡等购买凭证，或在维修时无法提供购买凭证。\n因操作（安装）不当导致的故障或损坏\n因进水、摔落或受压（例如脚踩等）导致的故障或损坏\n因改装或非正规维修导致的故障或损坏\n因火灾、地震、风灾水灾、雷击或其他自然灾害导致的故障或损坏\n运输过程中导致的故障或损坏\n因停电、雷击或异常高压导致的故障或损坏\n因设置了其他设备导致的故障或损坏`
        }
      },
      sony: {
        desc: `在全球47个国家和地区提供国际保修（维修服务）。请与本公司联系，届时将告知后续手续。请点击以下链接查看适用国家和地区\n\n`,
        title: `SONY`
      },
      watch: {
        brandList: (
          seikoUrl: string,
          citizenUrl: string,
          seikoEpsonUrl: string,
          anchorTagClassName: string,
          listTagClassName: string
        ) =>
          `<li class=${listTagClassName}>精工表株式会社: <a href=${seikoUrl} class=${anchorTagClassName} target='_blank'>${seikoUrl}</a>（保修期1年）</li>\n<li class=${listTagClassName}>西铁城时计株式会社: <a href=${citizenUrl} class=${anchorTagClassName} target='_blank'>${citizenUrl}</a>（保修期1年）</li>\n<li class=${listTagClassName}>精工爱普生株式会社（orient东方表）: <a href=${seikoEpsonUrl} class=${anchorTagClassName} target='_blank'>${seikoEpsonUrl}</a>（保修期1年）</li>`,
        desc: `按原厂保修条款提供服务。\n请点击以下链接查看各厂家保修条款。`,
        title: `钟表`,
        precaution: {
          mainTexts: `经用户自行调整过的表带不在保修范围内\n【自动上链、动能】手表使用振动作为动力进行发电和储能。长时间不使用或每天仅使用数小时，则可能会出现停止或时间（秒针）误差等情况。请再次振动（使其发电）予以确认。（振动：请将手表持续摇动数分钟）\n关于石英表，购买时手表配备的电池是用于检测功能和性能的测试用电池。因此，在购买后电池寿命可能已经耗尽。\n【限量版】手表以及【机械手表/手动上链手表】【高价商品】一经收货，恕不接受因用户原因导致的退货，敬请知悉。`,
          title: `附注事项`
        }
      }
    },
    medicine: {
      Ingredients: `成分・分量`,
      Inquiries: `咨询方式`,
      InquiriesForClick: `咨询请点击此处`,
      administration: `用法・用量`,
      consult: `慎用`,
      contraindications: `禁忌`,
      couponText: (rate: number) => `所示价格${rate}折优惠`,
      discountText: `医药品优惠券`,
      distributorContact: `商品咨询窗口`,
      effects: `适应症・功效`,
      notice: `※购买前请务必阅读「注意事项」。\n※依据法律规定，在线商店中的医药品（供应商：SUGI杉药局 川口户塚店）无法免税，所有医药品均以含税价格销售。目前玩尽日本促销活动正火热上线中，所有医药品结算时自动优惠相当于消费税的金额。※仅购买医药品(供货商 : SUGI杉药局 川口户塚店)时，需要一次性购买不低于1000日元的商品。`,
      other: `其他注意事项`,
      precautions: `使用及保管上的注意事项`,
      shelfLife: `使用期限`,
      Information: {
        desc: (category: string, className: string) =>
          `・此商品为日本「${category}」。购买时请遵守本站标注的<span class=${className}>「禁忌」「慎用」事项以及「用法和剂量」，并务必在阅读「注意事项」后购买。</span>\n・如果对医药类商品有任何疑问，请在购买前咨询医生、药剂师或拥有贩卖医药品资质的人员。\n※本站出售的医药类商品使用期限均不小于6个月。`,
        title: `购买医药类商品的有关须知`
      },
      abused: {
        desc: `由于含有以下成分的医药类商品有被滥用而导致顾客健康受损的风险，日本法律规定在购买时必须确认以下事项，且每人限购1盒。`,
        title: `包含有滥用风险的医药类商品。请在购买前阅读以下注意事项。`,
        confirm: {
          least18years: `①购买药品者年满18岁`,
          notBoughtAnyMedicine: `②未在其他药店购买过有相同功效的药品。`,
          notMadeConsecutive: `③未长期购买、服用此次购买的药品，及其他有相同功效的药品`,
          title: `■购买者或使用者相关的注意事项`
        },
        ingredient: {
          desc: `・麻黄碱・可待因・双氢可待因・溴异戊酰脲・消旋盐酸甲基麻黄碱・伪麻黄碱`,
          title: `■请确认含有滥用等风险的成分\n（含有以下成分的医药类商品。）`
        }
      }
    },
    notice: {
      expectedRestockDate: (year: number, month: number, day: number) =>
        `此商品将于<em>${year}年${month}月${day}日</em>补货`,
      restockDateUndetermined: `此商品补货日期<em>尚未确定</em>。`,
      restockDateUndeterminedShort: `补货日期尚未确定`,
      restockNotificationEmail: `产品补货通知将发送至注册邮箱。`,
      restockNotificationEmailNote: `※补货日期可能有所变动。`,
      restockNotificationSet: `已设置补货提醒。`,
      restockNotificationSetup: `补货通知设置完成`,
      scheduledArrival: (month: number, day: number) => `预计于${month}月${day}日补货`,
      wishRestockNotification: `补货时通知我`
    },
    originalPoint: {
      title: (product: string) => `TODO: products.originalPoint.title@zh_cn`
    },
    promo: {
      labelText: `限时9折`
    },
    sort: {
      popular: `热度优先`,
      priceAsc: `低价优先`,
      priceDesc: `高价优先`
    },
    tokyuStore: {
      liquorLp: {
        brewery: `酒厂`,
        description: `由玩尽日本 购物与东急百货公司合作，为大家带来日本各地・融合传统与创新的酒厂精心酿造的优质清酒！`,
        intro: `日本各地都隐藏着不少只有内行才知道的“隐秘佳酿”，或一般渠道难以购得的珍贵当地美酒。由玩尽日本 购物与东急百货公司合作，为大家带来日本各地・融合传统与创新的酒厂精心酿造的优质清酒！`,
        otherRecommendedSake: `其他\n推荐\n日本清酒`,
        recommendedWayToDrink: `推荐饮用方式`,
        title: `优质清酒`,
        typeOfSake: `清酒种类`,
        dassai: {
          alcoholContent: `15`,
          brandName: `DASSAI（獭祭）`,
          brewery: `旭酒造株式会社`,
          breweryDesc: `旭酒造致力于酿造“好喝美味、开怀畅饮”的清酒，而非大众营销逻辑下“好卖、好醉”的酒。不断地提供与酒相伴的辛福生活，也是旭酒造不断追求的理念。`,
          breweryDescTitle: `不为卖醉，不为营销，\n一心追求经得起品味的美酒`,
          breweryUrl: `https://www.asahishuzo.ne.jp/about/`,
          breweryUrlTitle: `引自　旭酒造株式会社官网`,
          characteristic: `使用研磨至极限的23%山田锦，最高品级纯米大吟酿`,
          ingredients: `100%山田锦、酒曲`,
          netContent: `720mL`,
          polishingRatio: `23`,
          price: `5700`,
          productDesc: `香气华丽使人陶醉，口感如蜂蜜般甜美，饮下后余韵清爽，回味悠长。獭祭的旗舰产品。`,
          productName: `獭祭 纯米大吟酿 二割三分 \n木盒装 720mL`,
          productionArea: `山口县`,
          recommendedWayToDrink: `冷酒・常温`,
          storageMethod: `温差变化较小的阴凉处\n如需长期保存，建议冷藏`,
          typeOfSake: `纯米大吟酿`
        },
        hakkaisan: {
          alcoholContent: `17`,
          brandName: `HAKKAISAN（八海山）`,
          brewery: `HAKKAISAN BREWERY（八海酿造）`,
          breweryDesc: `酒厂创业于1923年，坐落在日本降雪量最大的新潟县鱼沼地区。\n酿酒用水取自受灵峰八海山的极软水「雷电神之清水」，八海酿造致力于打造“清淡爽口，令人百喝不厌，衬托食物美味同时，又能烘托餐桌氛围的日本清酒”。`,
          breweryDescTitle: `打造不影响料理风味，让人百喝不厌的日本清酒`,
          breweryUrl: `https://ec-hakkaisan.com/pages/about`,
          breweryUrlTitle: `引用自　八海山官网`,
          characteristic: `清爽风味中，蕴含丰富口感。\n出自浩和酒藏的纯米大吟酿。`,
          ingredients: `米（兵库县产 山田锦）、酒曲`,
          netContent: `720mL`,
          polishingRatio: `45`,
          price: `6000`,
          productDesc: `倾注了酿酒师技艺与热情的精品美酒，坚持品质不容一丝妥协。清爽风味中，蕴含丰富口感。作为能够衬托料理美味的「日本的日本清酒」，致力于为日本乃至全世界的餐桌增香添彩。`,
          productName: `八海山纯米大吟酿浩和藏酿造720mL`,
          productionArea: `新潟县`,
          recommendedWayToDrink: `冷酒、常温`,
          storageMethod: `温差变化小的阴凉处\n如需长期保存，建议冷藏`,
          typeOfSake: `纯米吟酿酒`
        },
        imayoTsukasa: {
          alcoholContent: `17`,
          brandName: `Imayo Tsukasa（今代司）`,
          brewery: `Imayo Tsukasa（今代司酒造）`,
          breweryDesc: `今代司酒造由第一代但马屋十左卫门创建于1767年。最初经营的业务包括清酒批发、旅馆及餐饮业。\n从江户时代后期至明治时代初期，由于北前船（来往于日本海地区的贸易商船）频繁靠港，据说新潟的人口数量一度超过了江户。新潟地区的繁荣也得益于此，而位于新潟的今代司也随之兴盛发展至今。`,
          breweryDescTitle: `将日本清酒发扬光大的酒厂，广受人们喜爱。`,
          breweryUrl: `https://www.imayotsukasa.com/pages/aboutus`,
          breweryUrlTitle: `引自　今代司酒造株式会社官网`,
          characteristic: `将日本的两大魅力元素“锦鲤”与“清酒”完美结合。\n荣获设计大奖的日本清酒，也是送礼的最佳选择。`,
          ingredients: `米（日本产）、酒曲（日本产米）`,
          netContent: `720mL`,
          polishingRatio: `0`,
          price: `5600`,
          productDesc: `清酒「锦鲤」有如锦鲤一般绚丽，其纯正清爽的口感令人印象深刻。\n当今越来越多的人仅凭数据挑选酒类，而「锦鲤」一反其道，选择不公开酒品规格。\n仅通过鼻与口以及眼睛细品「锦鲤」的色香味，体验“纯粹”的新款清酒。`,
          productName: `今代司「锦鲤」盒装　720mL`,
          productionArea: `新潟县`,
          recommendedWayToDrink: `冷酒`,
          storageMethod: `温差变化较小的阴凉处\n如需长期保存，建议冷藏`,
          typeOfSake: `非公开`
        },
        mizubasho: {
          alcoholContent: `13`,
          brandName: `MIZUBASHO（水芭蕉）`,
          brewery: `Nagai Sake（永井酒造）`,
          breweryDesc: `永井酒造成立于1890年，继承了日本先人们所珍爱的自然和稻米文化，打造全新风格的日本清酒，向世界发起挑战。`,
          breweryDescTitle: `发掘日本清酒新纪元的酒厂`,
          breweryUrl: `https://nagai-sake.co.jp/`,
          breweryUrlTitle: `引自　永井酒造株式会社官网`,
          characteristic: `采用与香槟相同的酿造方法，经过10年的构思及数百次的试验和失败，最终诞生的气泡清酒。`,
          ingredients: `米（日本产）、酒曲（日本产米）`,
          netContent: `720mL`,
          polishingRatio: `0`,
          price: `5255`,
          productDesc: `气泡细腻如香槟，口感华丽且优雅。在传统清酒酿造中加入了瓶内二次发酵工艺，打造正宗的气泡清酒。这款珍品「前所未有的口感」令世界顶级大厨们惊叹不已。带有樱桃和荔枝的芳香，丝滑的气泡如妖精般包裹起料理，带给人无上的体验。`,
          productName: `MIZUBASHO PURE 720mL`,
          productionArea: `群马县`,
          recommendedWayToDrink: `冷酒`,
          storageMethod: `温差变化较小的阴凉处\n如需长期保存，建议冷藏`,
          typeOfSake: `气泡清酒`
        },
        otherRecommendation: {
          moreRecommendedSake: `查看更多精选日本清酒！`
        },
        sakeIntro: {
          classBasics: `有特定名称的清酒比普通清酒在用料上更为讲究，以①大米的精米步合（即酒米被研磨的程度）、②是否使用吟酿制法、③是否含有酿造用酒精来划分。`,
          daiginjo: `大吟酿酒`,
          forBeginner: `不少人刚接触日本清酒时，可能会一时难以接受其独特的风味，因此推荐以精米步合较低的清酒作为入门酒。`,
          futsushu: `普通酒`,
          ginjo: `吟酿酒`,
          honjozo: `本酿造酒`,
          junmaiDaiginjo: `纯米大吟酿酒`,
          junmaiGinjo: `纯米吟酿酒`,
          junmaishu: `纯米酒`,
          polishing: `一般来说，精米步合的数字越小（即酒米被磨去更多），清酒中的杂味更少，口感也更清纯，多为酒香浓郁的上乘佳品。这是因为酒米被更多地研磨掉外层，可以去除酒米中的蛋白质和脂肪等杂质，使风味更加纯净。`,
          polishingRatioAnnotation: `＊精米步合指「研磨后的精米（去除糙米表层后的米），占原本糙米的比例，以百分比表示」`,
          title: `日本清酒\n小知识`,
          jozo: {
            ingredients: `米、水、酒曲、酿造用酒精`
          },
          junmai: {
            ingredients: `米、水、酒曲`
          }
        },
        shochikubai: {
          alcoholContent: `15`,
          brandName: `Sho Chiku Bai（松竹梅）`,
          brewery: `TAKARA SHUZO（宝酒造）`,
          breweryDesc: `肥沃的土地、充足的阳光及雨露，这些来自大自然的恩惠皆被宝酒造视为至宝。宝酒造坚守品质，感恩自然，致力于打造优质产品。`,
          breweryDescTitle: `京都伏见　老字号酒厂`,
          breweryUrl: `https://www.takarashuzo.co.jp/takarahatakara/`,
          breweryUrlTitle: `引自　宝酒造官网`,
          characteristic: `来自老字号酒厂「松竹梅」，体现了品牌的吉祥寓意。`,
          ingredients: `米（日本产）、酒曲（日本产米）`,
          netContent: `1800mL`,
          polishingRatio: `0`,
          price: `5317`,
          productDesc: `松竹梅的本酿造酒，采用日式传统方樽包装，适用于各种庆祝场合，口感顺滑清爽。`,
          productName: `松竹梅「祝樽」1.8L`,
          productionArea: `京都府`,
          recommendedWayToDrink: `温燗（加热至40℃）、热燗（加热至50℃）`,
          storageMethod: `温差变化较小的阴凉处\n如需长期保存，建议冷藏`,
          typeOfSake: `本酿造酒`
        }
      }
    }
  },
  question: {
    answerCount: (count: number) => `回答（${count}）`,
    answerReceived: `已收到您的回答。`,
    answerUsefulThings: `请直言不讳，提供您的宝贵意见吧`,
    askEveryone: `向大家提问`,
    assistOthers: `请帮助他人，回他们的咨询吧！`,
    completed: `完成`,
    mayBeDeleted: `※不适当的问题・答案可能会由玩尽日本 免税购物运营方进行删除，敬请注意。`,
    notifiedViaEmail: `收到问题的解答时，将以邮件形式通知您。`,
    post: `发布`,
    postDetailedQuestion: `投稿详细描述的问题，能得到更准确的答案。`,
    postQuestion: `投稿新提问`,
    questionsMayBeAnsweredByWAmazing: `可能由玩尽日本的工作人员为您解答。`,
    received: `已收到您的问题。`,
    responseWillBeNotified: `您的回答将通知给提问者。`,
    thankYouForAnswer: `感谢提供有帮助的信息！`
  },
  questionnaire: {
    aboutTheSurvey: `关于问卷调查`,
    afterYouPicked: (answer: string, coupon: string) =>
      `※取货后<span class=${answer}>填写问卷调查</span>，即可获得价值<span class=${coupon}>1000日元的优惠券</span>。`,
    answer: `回答问卷`,
    answerAfterPaid: `或者在支付余额后，点击确认邮件中的链接回答问卷`,
    answerFromOrder: `点击订单详情页面的链接回答问卷`,
    coupon: (className?: string) => `<span class=${className}>1000日元</span>的优惠券`,
    fiveSecond: `只需5秒`,
    get: `获得`,
    pickUpCompleted: `完成取货后`,
    popup: (url: string, className: string) =>
      `<a href=${url} class=${className} target='_blank'>请帮忙填写购物问卷</a>\n感谢您的配合！`,
    survey: `回答问卷`
  },
  questionnaireModal: {
    fiveSecond: `只需5秒回答简单问卷`,
    getCoupon: `即可获得1000日元优惠券`,
    todayNotShow: `今日不再显示`
  },
  ranking: {
    description: `日本商品人气排行。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
    popular: `人气排行`,
    title: `热销排行榜`,
    titleName: `排行`,
    meta: {
      title: `日本商品人气排行`
    }
  },
  receive: {
    vjwRegistrationInfo: `<div class="text-sm mt-2.5">如需在指定设施领取免税商品，<span class="text-primary">必须在入境日本后注册VJW（Visit Japan Web）</span></div>`,
    detail: {
      address: `地址`,
      counterDescription: `在日本各地酒店或其他地点，面对面完成手续，直接领取商品`,
      lockerDescription: `日本各地机场、车站和巴士中心等地设有无人取货柜，轻松领取购买的商品`,
      map: `地图`,
      notRequired: `不需要`,
      pickupAvailableTime: `可取货时间`,
      pickupLocationDetail: `取货地点详情`,
      pickupLocationInfo: `取货地点信息`,
      receiveAtCounter: `人工取货`,
      receiveAtLocker: `在取货柜取货`,
      required: (url: string) =>
        `必须（<a class="underline" href=${url} target="_blank" rel="noopener noreferrer">查看注册方式</a>）`,
      view: `查看详情`,
      viewOnMapApp: `通过地图APP查看`,
      vjwRegistration: `注册VJW`,
      vjwRequiredNote: `※必须注册VJW`
    },
    list: {
      pickupLocation: `取货地点`,
      popularRegions: `人气地区`,
      selectPickupLocation: `选择取货地点`
    },
    navigation: {
      backToPickupList: `返回取货地点一览`,
      next: `下一步`,
      select: `选择`
    },
    vjw: {
      counterInfo: (url: string) =>
        `・若要通过面对面领取办理免税手续，<span class="text-primary font-medium">入境日本后<a href=${url} target="_blank" rel="noopener noreferrer" class="underline">必须注册 VJW（Visit Japan Web）</a></span>`,
      pleaseCheck: `请务必确认。`,
      registrationRequired: `■请注册Visit Japan Web`
    }
  },
  recommended: {
    description: `玩尽日本精选日本人气商品一览。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
    mustBuyPopularJapaneseGoods: `日本必买热销商品`,
    popularJapaneseCosmetics: `日本热销护肤品、化妆品`,
    popularJapaneseSnacks: `日本热销零食、小吃`,
    popularProducts: `热门推荐商品`,
    title: `精选日本人气免税商品`,
    viewMorePopularCosmetics: `查看更多热销护肤、化妆品`,
    viewMorePopularSnacks: `查看更多热销零食`,
    cosmetics: {
      description: `玩尽日本购物在日本提供各种流行和推荐的护肤品和化妆品品牌。 你可以在网站上找到你想要的产品，并一次性买下它们! 这对于那些想在选择纪念品时节省时间的人来说是非常理想的。 购买的物品可以在指定的机场和地点取走。 这使你不必携带大型行李，使你的日本之行更加舒适。`
    }
  },
  recommendedArticles: {
    title: `推荐阅读的相关内容`
  },
  referral: {
    label: `TODO: referral.label@zh_cn`,
    pageDescription: `TODO: referral.pageDescription@zh_cn`,
    pageTitle: `TODO: referral.pageTitle@zh_cn`,
    startShopping: `TODO: referral.startShopping@zh_cn`
  },
  registerCampaign: {
    campaignInProgress: `优惠活动实施中`,
    entryAndRegister: `需点此注册新会员`,
    fiveHundredOff: (border: string, thousand: string, yen: string, off: string) =>
      `<span class=${off}>立减</span><span class=${border}><span class=${thousand}>500</span><span class=${yen}>日元</span></span>`,
    fiveHundredOffForBanner: (discount: string, coupon: string) =>
      `<span class=${discount}>500日元</span><span class=${coupon}>优惠券</span>`,
    getCouponByEntryAndRegistration: `只需点击此处注册新会员\n即可获得优惠券！`,
    signUpAndGetCoupon: (className: string) => `立刻注册可<span class=${className}>获得1000日元优惠券！</span>`
  },
  reviewSubmit: {
    button: `发布评价`,
    howLike: `您喜欢这件商品吗？`,
    optional: `选填`,
    pleaseLogin: `输入评论请先登录账号`,
    required: `必填`,
    thanksForReview: `感谢您的评价`,
    guide: {
      agree: (button: string) => `我同意有关发表评价的${button}`,
      button: `注意事项`,
      content: `・在发布评价时，请理解评价发布功能基于以下目的。\n・此平台供发布者主观评价商品，并提交评分和评价\n・此平台收集基于发布者经验的评价信息\n・请尽量避免使用多余的字符、空格、平假名、颜文字及换行。\n・评价不得包含以下内容，如有违规，本公司将对评价予以删除、编辑等必要措施。\n　・侵犯或可能侵犯本公司、服务提供商或第三方的版权、名誉、隐私、肖像权等权利的内容\n　・歧视、诽谤或诋毁本公司、服务提供商、第三方的内容，或具有诋毁性质的内容\n　・涉及或鼓励犯罪行为的内容\n　・违反法律或公德良序的内容\n　・含有商业宣传目的的内容\n　・含有特定政治或宗教主张的内容\n　・含有歧视性表达的内容\n　・含有淫秽、有害、低俗或其他令人反感的内容\n　・其他本公司认为不当的内容\n・评价将被翻译成各种语言，并发布于玩尽日本购物的页面上。是否发布于页面由本公司裁定。\n・本公司保留在不通知评价者的情况下，免费复制、引用、公开、提供、出版、发布或以其他方式使用评价内容的权利。且评价者同意不对本公司及本公司指定人行使与评价有关的著作人格权。\n・本公司保留在不通知评价者的情况下，删除或隐藏评价内容的权利。届时，本公司无义务解释删除或隐藏的原因。\n・评价者对评价内容承担全部责任，本公司对评价内容的准确性、可靠性、合法性、完整性、有效性或其他事项不承担任何责任。\n・对于发布的评价引发的任何疑问、投诉、索赔等问题由评价者自行解决，本公司概不负责。\n・关于本注意事项中未规定的事项，遵循玩尽日本的使用条款及隐私政策。`,
      title: `注意事项`
    },
    label: {
      comment: `评论`,
      nickname: `昵称`,
      title: `标题`
    },
    placeholder: {
      comment: `输入评论`,
      name: `输入要显示的名称`,
      title: `输入标题\n`
    }
  },
  reviewSummary: {
    anonymous: `匿名`,
    count: (count: number) => `${count}条`,
    productName: (productName: string) => `${productName}的评价`,
    reviewCount: (count: number) => `${count}条评价`,
    shareReview: `与大家分享这件商品！`,
    showOriginal: `显示原文`,
    showTranslated: `显示翻译`,
    title: `评价`,
    userName: (userName: string) => `${userName}`,
    age: {
      fifty: `50~59岁`,
      forty: `40~49岁`,
      sixty: `60岁及以上`,
      ten: `19岁及以下`,
      thirty: `30~39岁`,
      title: `年龄`,
      twenty: `20~29岁`
    },
    gender: {
      female: `女性`,
      male: `男性`,
      other: `不作回答`,
      title: `性别`
    }
  },
  sakeNotice: {
    text1: `年龄确认`
  },
  search: {
    brandOrProductOrProduct: `品牌，商品，型号等`,
    enterKeywordsAlert: `请输入商品名等关键字进行检索`,
    history: `历史搜索`,
    keyword: `关键词`,
    noResultFor: (keyword: string) =>
      `没有检索到跟「${keyword}」一致的商品，若输入的关键字无误，请尝试其他关键字进行搜索。`,
    popularKeywords: `热门关键词`,
    recommendedKeywords: `推荐关键词`,
    search: `搜索`,
    searchItems: `搜索商品`,
    searchResultFor: (keyword: string) => `「${keyword}」的搜索结果`,
    searchingFor: (keyword: string) => `正在搜索「${keyword}」……`,
    meta: {
      description: `搜索结果。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
      title: `搜索结果`
    }
  },
  service: {
    useFreeECshopTitle: `WAmazing免稅EC服务使用规则`
  },
  shops: {
    commonMapDescription: (className: string) =>
      `* 订单可在收货日期前<span class=${className}> 最多3个月下订单</span>。\n* <span class=${className}>可以在前往日本之前购买。</span>\n* 显示时间为日本时间。`,
    list: `取货点列表`,
    mapTitle: `取货位置指南`,
    pickupAvailableDates: `可取货日期`,
    placeholder: `请选择取货柜台`,
    centrair_shop: {
      listPickupLocation: `中部国际机场-交通广场2楼`,
      lockersLocation: `中部国际机场取货路线指南`,
      routeInformationByBusTaxi: `路线指南（搭乘巴士或出租车的旅客）`,
      routeInformationByTrain: `路线指南（搭乘电车的旅客）`,
      route: {
        busTaxi: {
          step1: `①下车后请前往第1航站楼的2楼，向交通广场方向前进。`,
          step2: `②进入交通广场后继续直走。`,
          step3: `③沿路走到最里面。`,
          step4: `④取货柜设于最尽头的位置。`,
          step5: `④左手边即是WAmazing玩尽日本取货柜。快来解锁轻松方便的免税购物方式吧！`
        },
        train: {
          step1: `①下车通过检票闸机后，立刻左转前进。`,
          step2: `②沿路直行。`,
          step3: `③取货柜设于最尽头的位置。`,
          step4: `④左手边即是WAmazing玩尽日本取货柜。快来解锁轻松方便的免税购物方式吧！`
        }
      }
    },
    hakata_station_shop: {
      listPickupLocation: `JR博多站取货指南地图`,
      lockersLocation: `2楼西卡里广场内`,
      routeInformationByBulletTrain: `路线指南（于新干线博多站下车的旅客）`,
      routeInformationByCar: `路线指南（自驾前往的旅客）`,
      routeInformationByJR: `路线指南（于JR博多站下车的旅客）`,
      route: {
        finish: (number: string) => `${number}看到玩尽日本的免税取货柜啦！\n快来解锁轻松方便的免税购物方式吧！`,
        bulletTrain: {
          step1: `①下车出检票口后，向正前方咖啡店的左侧前进。`,
          step2: `②左侧即可看到玩尽日本取货柜。`
        },
        car: {
          step1: `①从入口进站后向右方前进。`,
          step2: `②搭乘右侧自动扶梯前往2楼。`,
          step3: `③到达2楼后向右前方前进。`,
          step4: `④左侧即可看到玩尽日本取货柜。`
        },
        jr: {
          step1: `①下车出检票口后向售票处右侧前进。`,
          step2: `②继续直行。`,
          step3: `③搭乘左侧自动扶梯前往2楼。`,
          step4: `④到达2楼后向右前方前进。`,
          step5: `④左侧即可看到玩尽日本取货柜。`
        }
      }
    },
    haneda_shop: {
      listPickupLocation: `羽田机场第三航站楼的取货路线指南`,
      lockersLocation: `单轨电车羽田机场第三航站楼站内地图`,
      lockersLocationNotice: `※希望搭乘电梯的旅客请自行前往服务中心咨询。`,
      routeInformationByBusTaxi: `路线指南（搭乘巴士、出租车的旅客）`,
      routeInformationByKeikyu: `路线指南（搭乘京急线的旅客）`,
      routeInformationByMono: `路线指南（搭乘单轨电车的旅客）`,
      route: {
        busTaxi: {
          step1: `①从一楼的下车地点前往位于二楼到达大厅的单轨电车站。`,
          step2: `②在单轨电车售票机购买180日元的车票后通过检票闸机进入车站。`,
          step3: `③通过检票闸机后即可看到位于左边的WAmazing玩尽日本取货柜。快来解锁轻松方便的免税购物方式吧！`
        },
        keikyu: {
          step1: `①下车后向出口方向前进，出检票闸机。`,
          step2: `②出检票闸机后直走，乘坐位于左前方的自动扶梯前往二楼。`,
          step3: `③抵达二楼后，沿二楼到达大厅的标识左转。`,
          step4: `④沿到达大厅标识前进即可看到单轨电车的车站。请绕过电梯前往单轨电车的方向。`,
          step5: `⑤在单轨电车售票机购买180日元的车票，通过检票闸机进入车站。`,
          step6: `⑥通过检票闸机后即可看到位于左边的WAmazing玩尽日本取货柜。快来解锁轻松方便的免税购物方式吧！`
        },
        mono: {
          step1: `①下车后向出口方向前进，乘坐扶梯前往二楼。`,
          step2: `②下扶梯后沿路左转。`,
          step3: `③面前即是WAmazing玩尽日本取货柜。快来解锁轻松方便的免税购物方式吧！`
        }
      }
    },
    hiroshima_shop: {
      listPickupLocation: `广岛机场的取货地图`,
      lockersLocation: `2楼国际出发大厅`,
      routeInformationByBus: `路线指南（于广岛机场站（巴士）下车的旅客）`,
      routeInformationByInternational: `路线指南（从国际线前往）`,
      route: {
        bus: {
          step1: `①巴士下车后，搭乘自动扶梯前往2楼右侧国际出发大厅。`,
          step2: `②穿过中央的Soramy广场，朝右侧「外币兑换机」方向前进。`,
          step3: `③外币兑换机左侧即可看到玩尽日本取货柜。`,
          step4: `④看到玩尽日本的免税取货柜啦！\n快来解锁轻松方便的免税购物方式吧！`
        },
        international: {
          step1: `①国际线到达后，搭乘入境大厅的自动扶梯前往2楼，左拐直行。`,
          step2: `②朝右侧外币兑换机方向前进，即可在外币兑换机左侧看到玩尽日本取货柜。`,
          step3: `③看到玩尽日本的免税取货柜啦！\n快来解锁轻松方便的免税购物方式吧！`
        }
      }
    },
    kansai_shop: {
      listPickupLocation: `JR关西机场站的站内地图`,
      lockersLocation: `关西机场内取货柜的位置地图`,
      routeInformationByJR: `前往路线（乘坐JR线）`,
      routeInformationByOthers: `前往路线（乘坐JR线以外的交通方式）`,
      route: {
        jr: {
          step1: `①下车后，从站台上二楼（检票口楼层）。`,
          step2: `②抵达二楼看到巨大的地图看板后，左转。`,
          step3: `③前进至ATM处，绕过ATM。`,
          step4: `④绕过ATM后就能看到玩尽日本的免税取货柜啦！尽情享受轻松愉快的免税购物吧！`
        },
        others: {
          step1: `① 抵达关西国际机场第一航站楼后，请前往2楼的“JR关西机场站”。`,
          step1note: `*乘坐利木津巴士的旅客：请在抵达第一航站楼4楼国际线出发层之后，前往2楼。\n*乘船抵达的旅客：抵达关西机场的高速船码头后，请乘坐专用的机场摆渡车抵达第一航站楼4楼国际出发层后，前往2层。`,
          step2: `②在地铁售票处前往右侧蓝色看板处的JR售票处购买车票。`,
          step3: `③请在售票机购买150日元的车票后，进入后方的JR检票口。`,
          step4: `④进入检票口看到巨大的地图看板后左转。`
        }
      }
    },
    mapDescription: {
      centrair_shop: (className: string) =>
        `WAmazing玩尽日本取货柜位于<span class=${className}>中部国际机场-交通广场2楼</span>。`,
      hakata_station_shop: (className: string) =>
        `玩尽日本取货柜位于「JR博多站」<span class=${className}>2楼西卡里广场内</span>。`,
      haneda_shop: (className: string) =>
        `WAmazing玩尽日本取货柜位于羽田机场第三航站楼二楼到达大厅的“<span class=${className}>单轨电车检票闸机内</span>”。\n\n<span class=${className}>※建议乘坐单轨电车前往羽田机场。\n※使用其他交通工具前来的旅客，请另行购买单轨电车车票，进入闸机内取货。</span>`,
      hiroshima_shop: (className: string) =>
        `玩尽日本取货柜位于「广岛机场」<span class=${className}>2楼国际出发大厅</span>。`,
      kansai_shop: (className: string) =>
        `玩尽日本的取货柜设置在<span class=${className}>“JR关西机场站”</span>检票口内的二楼。\n\n<span class=${className}>※建议乘坐JR线前往机场。\n ※若使用其他路线前往机场的旅客，请另行购买JR车票后进入检票口取货。</span>`,
      naha_station_shop: (className: string) =>
        `玩尽日本取货柜位于「那霸机场」<span class=${className}>2楼的免费充电区</span>内。`,
      narita1_shop: (className: string) =>
        `玩尽日本取货柜设置在<span class=${className}>成田机场第1航站楼的JR成田机场</span>站内。\n\n※建议搭乘<span class=${className}>JR东日本</span>的电车，在<span class=${className}>成田机场站</span>下车。`,
      narita2_shop: (className: string) =>
        `玩尽日本取货柜位于<span class=${className}>成田机场第二候机楼站</span>内。\n\n※建议搭乘<span class=${className}>JR东日本</span>的电车，在<span class=${className}>成田机场第二候机楼站</span>下车。`,
      new_chitose_shop: (className: string) =>
        `WAmazing玩尽日本取货柜位于<span class=${className}>新千岁机场-国际线候机楼1楼</span>。\n\n※从JR车站到取货柜约需<span class=${className}>10分钟</span>。请预留充分的时间，以便取货。`,
      sendai_shop: (className: string) =>
        `玩尽日本取货柜位于『仙台国际机场』<span class=${className}>1楼国际到达大厅</span>。`,
      tenjin_shop: (className: string) =>
        `玩尽日本的免税取货柜设于<span class=${className}>天神客运总站3楼下车位置附近</span>。\n\n\n*推荐搭乘<span class=${className}>西日本铁道（西铁）</span>的列车，在<span class=${className}>西铁天神站</span>下车。\n`
    },
    messages: {
      earliestPickupDate: `最快取货日`,
      minimumPickUpTime: (year: string, month: string, day: string, hour: string, minute: string, className: string) =>
        `最快可取货时间：<span class=${className}>${year}年${month}月${day}日 ${hour}:${minute}起</span>`,
      minimumPickUpTimeSp: (
        year: string,
        month: string,
        day: string,
        hour: string,
        minute: string,
        className: string
      ) => `<span class=${className}>取货时间</span><span>${year}年${month}月${day}日 ${hour}:${minute}起</span>`
    },
    naha_shop: {
      listPickupLocation: `那霸机场取货指南图`,
      lockersLocation: `那霸机场2楼`,
      routeInformationByDomestic: `路线指南（从国内线前往）`,
      routeInformationByInternational: `路线指南（从国际线前往）`,
      route: {
        domestic: {
          step1: `①请向2楼国际线出发口D的方向前进。`,
          step2: `②在出发口D前左转，向有洗手间标识的方向继续前进。`,
          step3: `③走到尽头，即可在左侧看到玩尽日本取货柜。`
        },
        international: {
          step1: `①请向游客服务中心的方向前进，搭乘右侧的自动扶梯前往2楼。`,
          step2: `②到达2楼后，即可在左侧看到玩尽日本取货柜。`
        }
      }
    },
    narita1_shop: {
      listPickupLocation: `成田机场站的取货路线图`,
      lockersLocation: `成田机场站内地图`,
      routeInformationByJR: `路线指南（于JR东日本的成田机场站下车的顾客）`,
      routeInformationByKeisei: `路线指南（搭乘京成线的顾客）`,
      route: {
        finish: (routeNumber: string) => `${routeNumber}快来解锁轻松方便的免税购物方式吧！`,
        busTaxi: {
          step1: `①下车后向JR检票口方向前进。`,
          step2: `②在JR售票机购买150日元入场车票，通过检票闸机进入车站。`,
          step3: `③沿候车室方向前进，右侧即是玩尽日本取货柜。`
        },
        jr: {
          step1: `①下车后搭乘扶梯上楼。`,
          step2: `②向出口方向前进。`,
          step3: `③面向出口，左侧即可看到玩尽日本取货柜。`
        },
        keisei: {
          step1: `①下车乘扶梯上楼后，向出口方向前进。`,
          step2: `②出京成线后向JR检票口方向前进，再向左转。`,
          step3: `③在JR售票机购买150日元入场车票，通过检票闸机进入车站。`,
          step4: `④沿候车室方向前进，右侧即是玩尽日本取货柜。`,
          ticket: `※入场车票购买方式\n注意：取完货出站时，请向站内工作人员说明「使用了入场车票进站」。`
        }
      }
    },
    narita2_shop: {
      listPickupLocation: `成田机场第二候机楼站的取货路线指南`,
      lockersLocation: `成田机场第二候机楼站站内地图`,
      routeInformationByJR: `路线指南（于JR东日本的机场第二候机楼站下车的顾客）`,
      routeInformationKeisei: `路线指南（搭乘京成线的顾客）`,
      route: {
        busTaxi: {
          step1: `①下车后向JR检票口方向前进。`,
          step2: `②向JR检票口前进，在JR人工售票窗口购买入场车票。`,
          step3: `③通过JR检票闸机后，面向卫生间，右侧即是玩尽日本取货柜。`
        },
        jr: {
          step1: `①下车后搭乘扶梯上楼。`,
          step2: `②向检票口对面的卫生间方向前进。`,
          step3: `③面向卫生间，右侧即是玩尽日本取货柜。`
        },
        keisei: {
          step1: `①下车后搭乘扶梯上楼。`,
          step2: `②出检票闸机后左转。`,
          step3: `③向第2、３航站楼方向前进。`,
          step4: `④向JR检票口前进，在JR人工售票窗口购买入场车票。`,
          step5: `⑤通过JR检票闸机后，面向卫生间，右侧即是玩尽日本取货柜。`,
          ticket: `※入场车票示意图`
        }
      }
    },
    new_chitose_shop: {
      listPickupLocation: `新千岁机场的取货路线指南`,
      lockersLocation: `新千岁机场- 1楼`,
      routeInformationByBusTaxi: `路线指南（搭乘巴士或出租车的旅客）`,
      routeInformationByTrain: `路线指南（搭乘电车的旅客）`,
      route: {
        busTaxi: {
          step1: `①下车后，进入候机楼，上到2楼后，向「国际线」方向前进。`,
          step2: `②跟随「国际线」的指示牌，沿路直行至最里处。`,
          step3: `③道路尽头左转，继续前行。`,
          step4: `④经过便利店后，在道路尽头右转。`,
          step5: `⑤搭乘道路尽头的电梯，下至1楼。`,
          step6: `⑥下电梯后，向左手边直行。`,
          step7: `⑦径直向前即是WAmazing玩尽日本取货柜。快来解锁轻松方便的免税购物方式吧！`
        },
        train: {
          step1: `①下车通过检票闸机后，乘坐面前的电梯前往2楼。`,
          step2: `②出电梯后，向「国际线」方向前进。`,
          step3: `③跟随「国际线」的指示牌，沿路直行至最里处。`,
          step4: `④道路尽头左转，继续前行。`,
          step5: `⑤经过便利店后，在道路尽头右转。`,
          step6: `⑥搭乘道路尽头的电梯，下至1楼。`,
          step7: `⑦下电梯后，向左手边直行。`,
          step8: `⑧径直向前即是WAmazing玩尽日本取货柜。快来解锁轻松方便的免税购物方式吧！`
        }
      }
    },
    notice: {
      aboutOrder: `发货时间需要3天以上，请提早购买。`
    },
    sendai_shop: {
      listPickupLocation: `仙台国际机场的取货地图`,
      lockersLocation: `1楼国际到达大厅`,
      routeInformationByInternational: `路线说明（从国际线前往）`,
      routeInformationUseSdj: `路线说明（于仙台国际机场站下车）`,
      route: {
        international: {
          step1: `①国际线入境出口左侧即可看到玩尽日本取货柜。`
        },
        sdjInternational: {
          step1: `①出检票闸口后向右方前行。`,
          step2: `②走到尽头，按照指示牌往左转继续直行。`,
          step3: `③走到尽头，于出口向右方前行。`,
          step4: `④搭乘右侧扶梯前往1楼。`,
          step5: `⑤到达1楼后，前往左前方的国际到达大厅。`,
          step6: `⑥走到尽头即可在左侧看到玩尽日本取货柜。`
        }
      }
    },
    tableHeader: {
      receivableDate: `取货日期`,
      shopName: `取货地点名`
    },
    tenjin_shop: {
      listPickupLocation: `天神客运总站- 3楼`,
      lockersLocation: `天神客运总站的取货地图指南`,
      routeInfomation: `路线指南（于西铁天神站下车）`,
      route: {
        step1: `①下车出北检票口后左转。`,
        step2: `②根据「高速巴士（到达）」指示牌，前往巴士下车区域。`,
        step3: `③搭乘扶梯前往3楼。`,
        step4: `④下扶梯后向相反方向前进（途中会经过服务中心）。`,
        step5: `⑤继续直走到尽头，即可看到玩尽日本取货柜啦。`,
        step6: `⑥快来解锁轻松方便的免税购物方式吧！`
      }
    }
  },
  staticWalkthrough: {
    description: `玩尽日本购物服务介绍。购买日本免税商品，就用玩尽日本购物！超多日本人气美妆和当地零食商品。购买完成后，前往指定的机场即可轻松取货。`,
    heading: `玩尽日本服务介绍`,
    pickupsSectionHeading: `取货地点名`,
    safeAndConveneientShoppingService: (className: string) =>
      `可以在线上免税店预约好商品后，于<span class=${className}> 指定日本机场领取商品</span>的「安心、方便的免税购物服务」。`,
    serviceBenefitsHeading: `服务的便利之处`,
    serviceBenefitsSubheading: `可轻松解决旅程中购物的各种问题，能更高效地利用有限的时间畅玩日本。`,
    title: `服务介绍`,
    aboutPurchase: {
      btn: `确认「日本免稅制度」`,
      heading: `关于免税购物`,
      listItem1: `・一次购买5,000日元(不含税)或以上即可免税 \n`,
      listItem2: `・免税手续仅适用于持有短期居留签证的游客`,
      listItem3: `・每人1天最多可购买50万日元的免税商品`,
      listItem4: `・请于取货日前3天预订。`
    },
    banner: {
      banner1: {
        text: `热门化妆品推荐`,
        title: `可安心选购`
      },
      banner2: {
        text: `热门零食推荐`,
        title: `必买`
      }
    },
    faqs: {
      answer1: `可以，只要是停留在日本国内的期间，均可任意选择取货时间。`,
      answer2: `付款方式为在线支付。\n目前支持VISA、Mastercard（万事达）、JCB、American Express（美国运通）。\n使用微信支付的用户，取货时也需要使用微信支付尾款。`,
      answer3: `已成立的订单无法变更领取时间，请取消后再次重新购买。`,
      answer4: `・结账时须确保手机的网络连接。请务必准备好网络环境。\n・仅限预购者本人办理手续。请务必由预购者本人到场。\n・为完成购买手续，预购者本人须出示护照以及护照上的入境许可贴纸，请务必携带至现场。\n      办理手续仅限含芯片的电子护照，以及有效期限内的入境许可贴纸。\n・为完成购买手续，需拍摄预购者本人的脸部照片，敬请理解。\n・取货时需用信用卡结账。请留意信用卡上限额度。`,
      btn: `确认所有常见问题`,
      heading: `常见问题`,
      question1: `可以在出境日以外的时间领取商品吗？`,
      question2: `如何付款？`,
      question3: `可以更改领取日期吗？`,
      question4: `领取商品时需出示什么东西？`
    },
    serviceBenefits: {
      issueLink: `取货失败时，请点此处`,
      card1: {
        body: (className: string) =>
          `适合对于因语言不通而<span class=${className}>苦于寻找店铺 </span>、雨天<span class=${className}> 怕被淋湿</span>、购物<span class=${className}> 不想排队</span>等方面有顾虑的游客。\n`,
        footer: `网上轻松下单`,
        title: `寻找店铺非常麻烦`
      },
      card2: {
        body: (className: string) =>
          `适合因购物太多而需<span class=${className}>手提大量商品出行 </span>，旅程还未结束就需要手提商品<span class=${className}>乘坐电车很麻烦 </span>，而且还是<span class=${className}>受人之托所买 </span>而倍感麻烦的游客。\n`,
        footer: `可以到机场领取轻松方便`,
        title: `手提商品出行十分不便`
      },
      card3: {
        body: (className: string) =>
          `适合因<span class=${className}> 部分店铺不能免税、语言不通、店铺收取免税手续费</span>等，而感到麻烦的游客。`,
        footer: `免税资格确认十分简单`,
        title: `担心免税手续不顺利`
      },
      card4: {
        body: (className: string) =>
          `适合<span class=${className}>担心人群密集 </span>、而想要尽量<span class=${className}> 减少与人接触及非必要沟通</span>、希望尽量<span class=${className}> 降低各种感染风险</span>的游客。\n`,
        footer: `无需当面取货`,
        title: `对与人接触仍感不安`
      },
      card5: {
        body: (className: string) =>
          `适合因为是跟团旅游，行程被规定好<span class=${className}> 没有时间购物</span>，只能去<span class=${className}> 旅行社安排好的购物中心</span>，而感到不满的游客。\n`,
        footer: `跟团旅游也能尽情购物`,
        title: `没有自由时间`
      },
      card6: {
        body: (className: string) =>
          `适合<span class=${className}>担心商品并非正品 </span>，不想因为用假货送礼而感到尴尬，因此想在令人放心的地方购物的游客。\n`,
        footer: `放心正品`,
        title: `担心是假货`
      },
      card7: {
        body: (className: string) =>
          `适合担心搞错日期而<span class=${className}> 无法取货</span>，搞错取货地点而<span class=${className}>无法取货 </span>等情况发生的游客。\n`,
        footer: `令人安心的全方位协助`,
        title: `担心各种情况发生`
      }
    },
    serviceUsageFlow: {
      heading: `服务使用流程`,
      usageCard1: {
        body: `除了日本经典特产礼品外，还可以在网上轻松买到日本全国各地的限定特产礼品！`,
        title: `网上购物`
      },
      usageCard2: {
        body: `只需原价20%的价钱即可轻松预订想买的商品！`,
        title: `支付预付款`
      },
      usageCard3: {
        body: `在领取地点支付80%的余额，并在确认免税资格后立即领取商品！`,
        title: `在领取地点\n完成付款并领取商品`
      }
    }
  },
  systemMaintenance: {
    text: `9/26（星期四）4:30〜5:30（日本标准时间）将进行系统维护。在此期间，玩尽日本 购物的网页版和APP版均将无法使用，敬请谅解。`
  },
  taxFreeGuide: {
    description: (className: string) =>
      `难得来享受日本之旅！除了欣赏各个时尚和富有历史的旅游景点之外，购物也是旅途的一大重点！难得有机会，当然要<span class=${className}>以优惠的免税价格尽情购物</span>！\n针对抱有「担心能否顺利沟通」「免税的条件是什么？」「不想因出错而留下不好的回忆」等想法的旅客！无需再确认<span class=${className}>日本的免税手续</span>，一起享受方便又顺利的日本免税购物之旅吧！`,
    title: `日本免税指南`,
    TaxExemption: {
      heading: `日本的免税制度是什么？`,
      Item1: {
        description: `以持有6个月之内的短期滞留签证的外国人为对象。办理免税手续时，需出示贴有有效的短期滞留签证贴纸的护照。`,
        title: `以持有短期滞留签证者为免税对象`
      },
      Item2: {
        description: `单次消费满5000元以上即可享受免税价格购物。\n若购买消耗品，在同一店铺内单日消费不能超过50万日元（税前价格）。`,
        title: `需消费满5000日元以上才能免税`
      },
      Item3: {
        description: `部分适用轻减税率的商品税率为8%。`,
        title: `可直接免除10%消费税`
      }
    },
    dutyFree: {
      description: `标有Tax-free shop标记的网店、药妆店、百货公司、便利店等皆可提供免税服务。`,
      heading: `在日本哪些商店可以购买免税商品？`,
      card1: {
        d1: `免税手续`,
        d2: `轻松在网上购物`,
        d3: `无需面对店员`,
        d4: `无需面对店员，更加安心`,
        d5: `轻便`,
        d6: `将商品直接运送至机场，旅途更加轻松`,
        description: (className: string) =>
          `语言不通的同时还要<span class=${className}>寻找能买到心仪商品的店铺</span>、还有<span class=${className}>排队</span>和<span class=${className}>下雨时会淋湿</span>等需要<span class=${className}>担心</span>的问题，这时网店是您的最佳选择。`,
        heading: `网店`
      },
      card2: {
        d1: `免税手续`,
        d2: `可以当场退税`,
        d3: `无需面对店员`,
        d4: `面对面`,
        d5: `轻便`,
        d6: `需要带着行李移动`,
        description: (className: string) =>
          `逛街虽然过瘾，但是<span class=${className}>提着沉重的行李却十分麻烦</span>，若是接下来有行程要<span class=${className}>搭乘电车就更令人头疼了</span>，或是因<span class=${className}>帮亲友代买</span>而感到<span class=${className}>繁琐</span>，这时在网上购物是您的最佳选择。`,
        heading: `药妆店`
      },
      card3: {
        d1: `免税手续`,
        d2: `耗费时间`,
        d3: `无需面对店员`,
        d4: `面对面`,
        d5: `轻便`,
        d6: `需要带着行李移动`,
        description: (className: string) =>
          `适合因<span class=${className}> 部分店铺不能免税、语言不通、店铺收取免税手续费</span>等，而感到麻烦的游客。`,
        heading: `百货公司`
      }
    },
    dutyFreeFlow: {
      heading: `确认网上免税店的\n购物流程`
    },
    dutyFreePrecautions: {
      heading: `在日本购买免税商品的注意事项`,
      info: `・属于消耗品的免税商品，不可以在日本国内打开包装和使用。\n・离开日本前不可以将免税商品转让给他人。\n・持饮品、调味料、化妆品等液体等上飞机时，需遵守航空公司的限制规定。\n・若将免税品邮寄至海外，需向海关出示邮局发行的收据、寄件发票等。\n・必须由购买者本人将免税品带离日本。`
    },
    faqs: {
      answer1: `DUTY FREE：基于关税法的免税制度，消费税、关税、酒税、香烟税均为免税对象。店铺主要位于国际机场的出境后区域。\nTAX FREE：基于消费税法的免税制度，以一般可购买的物品、消耗品为对象。对象店铺主要位于街上的购物区。`,
      answer2: `基于新免税制度，办理免税手续时须出示「护照」和「已购买的免税商品」。`,
      answer3: `不能。必须于购买当日办理免税手续。`,
      answer4: `使用机场自助通关入境日本时，不会在护照上盖入境印章，因此有可能导致无法办理免税手续。建议事先向入国管理局索取入境印章，以防万一。`,
      answer5: `可携带入飞机内的液体上限为100ml,超过此容量则不能带上飞机。但若符合以下条件则可以带入飞机内：\n・将液体商品放入托运行李\n・出境后购买的液体免税商品（※仅限直飞的旅客）`,
      answer6: `不能，免税手续只能由购买者本人办理。`,
      answer7: `不能，将免税商品携带出境是购买者本人的义务。`,
      heading: `免税手续的常见问题`,
      question1: `「DUTY FREE」和「TAX FREE」有什么区别？`,
      question2: `办理免税手续时需要出示什么？`,
      question3: `能否于购买后第二天办理免税手续？`,
      question4: `若使用机场自助通关入境日本能否办理免税手续？`,
      question5: `液体商品可否带入飞机内？`,
      question6: `免税手续可否由他人代办？`,
      question7: `能否由他人将免税商品携带出境？`
    },
    meta: {
      description: `免税手续 | 免税购物 | 关于日本免税店。来日本旅行时随时可以购买各种纪念品，购买更优惠、更轻松，请选择玩尽日本免税购物！`,
      title: `日本免税购物指南`
    },
    products: {
      description: `标有Tax-free shop标记的网店、药妆店、百货公司、便利店等皆可提供免税服务。`,
      heading: `在日本有哪些商品可以免税？`,
      card1: {
        info: `※每位符合免税条件的顾客，需于同一店铺的单日消费金额达到5000日元以上\n※可在日本国内使用，但必须入境6个月内携带出境`,
        item1: `首饰`,
        item2: `服饰`,
        item3: `箱包`,
        item4: `鞋子`,
        item5: `家电`,
        item6: `相机`,
        item7: `钟表`,
        title: `在日本可免税的一般商品`
      },
      card2: {
        info: `※每位符合免税条件的顾客，需于同一店铺的单日消费金额达到5000日元以上\n※不可在日本国内使用，且必须入境6个月内携带出境`,
        item1: `化妆品`,
        item2: `食品`,
        item3: `酒`,
        item4: `香烟`,
        item5: `保健食品`,
        item6: `医药品`,
        title: `在日本可免税的消耗性商品`
      }
    }
  },
  taxFreeShop: {
    article1: `第1条（条款的适用）`,
    article10: `第10条（本网站及本服务的暂时停止）`,
    article10Sentence1: `在下述各项的情况下，本公司可以不事先通知会员而暂时停止运营本网站及本免税EC服务：`,
    article10Sentence2: `(1)进行本网站的维护或设计变更时；`,
    article10Sentence3: `(2)发生或有可能发生自然灾害或其他紧急情况、导致无法运营本网站及本免税EC服务时；`,
    article10Sentence4: `(3)其他本公司判断因不得已的事由需要暂时停止运营本网站及本免税EC服务时。`,
    article11: `第11条（本公司的免责）`,
    article11Sentence1: `1.因自然灾害、线路拥堵、机器故障或维护导致的停机、商品供应商的信息丢失、或因第三方导致的信息篡改或泄露等原因产生的损害，除损害是因归责于本公司的事由造成的，本公司概不负责。`,
    article11Sentence2: `2.即使在本公司就会员对本免税EC服务的使用相关负责的情况下，除本公司的故意或重大过失外，本公司的责任仅限于直接且普通的损害。`,
    article12: `第12条（准据法、语言、管辖法院）`,
    article12Sentence1: `1.本免税EC服务使用条款以日本法为准据法，并按日本法予以解释。`,
    article12Sentence2: `2.本免税EC服务使用条款以日语为正文，并按日语予以解释和签订。本免税EC服务使用条款除日语之外的其他语言的翻译版本仅作参考之用，不对以日语对本免税EC服务使用条款进行的解释作任何变更。`,
    article12Sentence3: `3.就本免税EC服务使用条款产生的纠纷的第一审专属管辖法院为东京地方法院。`,
    article1Sentence1: `1.本免税EC服务使用条款适用于通过WAmazing株式会社（以下简称“本公司”）管理的网站（以下统称“本网站”）进行会员注册的会员使用本免税EC服务（参照下条的定义）时进行的一切行为，会员应在同意本免税EC服务使用条款后使用本免税EC服务。`,
    article1Sentence2: `2.如本公司于本免税EC服务中对各注意事项等（以下简称“各注意事项等”）进行了提示的，各注意事项等分别构成本免税EC服务使用条款的一部分。`,
    article1Sentence3: `3.本公司可无需事先通知会员而随时修改本免税EC服务使用条款，本公司修改后的本免税EC服务使用条款于刊载在本公司指定网站之时（如对本公司修改后的本免税EC服务使用条款的生效日有另行设定的，以该另行设定之日为准）发生效力。会员在修改后使用本免税EC服务的，视为同意修改后的本免税EC服务使用条款。`,
    article2: `第2条（本免税EC服务的定义及买卖预约合同的成立）`,
    article2Sentence1: `1.本免税EC服务是指，会员自发地通过本网站使用能达成以下目的的服务：`,
    article2Sentence2: `① 购买及预约购买本公司在本网站上刊载的商品`,
    article2Sentence3: `2.会员可在本网站上通过以下方式进行商品购买的预约：`,
    article2Sentence4: `① 用户完成在本网站上输入本公司指定的必要信息（包括用户信息、订单信息、支付信息等）、在本网站上申请商品的预约购买、并支付第4条规定的预付款的同时，预约完成。此外，在本网站上完成预约的时刻，本公司和用户之间就该商品的买卖预约合同（以下简称“买卖预约合同”）同时成立。`,
    article2Sentence5: `3.可预约期间为本网站上公示的期间。`,
    article2Sentence6: `4.为证明买卖预约合同的成立，本公司将在本网站内的会员页面发送“买卖预约合同成立画面”。`,
    article2Sentence7: `5.本公司和会员之间根据本条规定成立买卖预约合同的，视为会员已接受自行承担第5条规定的取消费用等的义务。`,
    article3: `第3条（商品价格的变更等）`,
    article3Sentence1: `1.会员知晓，本网站上刊载的关于商品价格等的信息可能会与其他媒体提供的信息有所差异。`,
    article3Sentence2: `2.会员知晓，商品价格等可能会不经预告地进行变更。变更后的商品价格等只对于变更后申请预约的会员适用，在变更前已进行了预约申请的会员适用变更前的商品价格等。`,
    article4: `第4条（商品预付款的支付）`,
    article4Sentence1: `用户应在进行商品的购买预约时向本公司支付相当于该商品价格的20%作为预付款（预付款中含消费税）。但，商品页面等中另有说明的，应从其说明。此外，用户取消或购入已预约商品之前均无权要求退还预付款。`,
    article5: `第5条（预约取消的成立和取消费用的产生）`,
    article5Sentence1: `1.会员可在购买预约时指定的收货日当天之前，根据买卖预约合同取消全部预约商品的购买预约。但，此种情况下，会员只能一次性取消全部商品的预约、不能仅取消部分商品的预约。`,
    article5Sentence2: `2.用户在商品向指定收货地点发货前取消商品的购买预约，该商品的取消不产生取消费。此种情况下，本公司根据上条进行预付款的退款处理。`,
    article5Sentence3: `3.用户在商品向指定收货地点发货后取消商品的购买预约，将产生预付款全额的取消费。但，商品页面等中另有说明的，应从其说明。`,
    article5Sentence4: `4.用户在购买预约时指定的取货日当天之前没有对已预约商品进行购买或取消的意思表示的，视为用户取消该商品的预约，并产生预付款全额的取消费。但，商品页面等中另有说明的，应从其说明。`,
    article5Sentence5: `5.即使会员不希望取消预约，但本公司根据会员就本免税EC服务使用相关的预约内容判断其违反了法律法规等规定或可合理地判断为不适当的，本公司有权取消该预约。此种情况下的取消费用及退款处理根据上述各款执行。`,
    article6: `第6条（买卖合同的成立、商品价格的确定及商品的交付）`,
    article6Sentence1: `1.选择在本公司柜台收货的\n会员应在购买预约时指定的收货日、于购买预约时指定的收货地点的本公司柜台的营业时间内到店、对本公司进行购买已预约商品的意思表示，并完成本公司指定的手续时，会员与本公司之间就该商品的买卖合同成立，本公司对会员交付该商品。`,
    article6Sentence2: `2.选择在储物柜收货的\n会员应在购买预约时指定的收货日、于购买预约时指定的收货地点所在的储物柜对本公司表明进行购买已预约商品的意思，并根据本公司指定的手续操作完成时，会员与本公司之间就该商品的买卖合同成立，本公司对会员交付该商品。`,
    article6Sentence3: `3.本公司应将第4条的预付款抵作买卖合同成立后商品的价款。`,
    article6Sentence4: `4.会员在购买预约时指定的收货日当天之前没有对已预约商品进行购买或取消的意思表示的，本公司将其视为会员取消该商品的预约，此种情况的取消费用根据上条规定执行。`,
    article7: `第7条（会员的遵守事项）`,
    article7Sentence1: `1.未经本公司同意，会员不得将通过使用本网站获得的信息以个人使用以外的目的进行复制、传播等，也不得以任何形式提供给第三方使用。`,
    article7Sentence10: `(8) 拒不支付本公司请求的预付款、取消费或商品价款的行为（无论理由为何）；`,
    article7Sentence11: `(9)对本公司或第三方的暴力或骚扰行为；`,
    article7Sentence12: `(10)被认定为以向他人转卖或以商用为目的的预约行为；`,
    article7Sentence13: `(11)其他任何违反或可能违反法律法规的行为。`,
    article7Sentence14: `3.如本公司或第三方因会员做出的前款各项的任一行为遭受损害的，会员应承担全部法律责任，不得对本公司及第三者造成任何损害。`,
    article7Sentence15: `4.如会员不满足法律法规等规定的就商品购买免征消费税的条件，但仍向本公司进行了购买已预约商品的意思表示的，除了该商品的价款外，会员应另行向本公司支付相当于该商品的消费税金额。`,
    article7Sentence16: `5.本公司根据第8条第1款取消了本免税EC服务使用相关的预约的，会员应根据第5条的规定支付取消费用。`,
    article7Sentence17: `6.如会员为未成年人，应取得法定代理人的同意后进行预约。如会员谎称其得到了法定代理人的同意或谎称其为成年人，其进行的预约行为也不能被取消。`,
    article7Sentence2: `2.在使用本免税EC服务时，会员不得有如下行为：`,
    article7Sentence3: `(1)冒充第三方发送或填写信息的行为；`,
    article7Sentence4: `(2)以本公司许可以外的方式使用本免税EC服务的行为；`,
    article7Sentence5: `(3)发送或写入有害计算机程序的行为，发送广告邮件、连环信件、垃圾邮件等行为；`,
    article7Sentence6: `(4)侵害或可能侵害本公司或第三方的著作权及其他知识产权的行为；`,
    article7Sentence7: `(5)对本公司及第三方进行诽谤、中伤或损害名誉的行为；`,
    article7Sentence8: `(6)向他人公开违反公序良俗的信息、文件及图像等的行为：`,
    article7Sentence9: `(7)无论是否故意，提供虚假或不完整的本免税EC服务的用户或会员个人的姓名、住所、电话号码、邮箱地址、信用卡号码等信息进行注册的行为；`,
    article8: `第8条（会员遵守事项的违反）`,
    article8Sentence1: `1.如会员违反上条规定的遵守事项或有其他被本公司判断为对本免税EC服务的运营上不利的情况的，本公司有权采取制止该行为、取消该会员与本公司的买卖预约合同或买卖合同、停止含本免税EC服务在内的与本网站相关的一切服务的使用、剥夺其会员资格或要求赔偿损失等必要的措施（包括法律措施）。`,
    article8Sentence2: `2.如本公司推测会员违反上条规定的遵守事项或有其他被本公司判断为对本免税EC服务的运营上不利的情况的，可向会员确认该行为的详细情况。`,
    article9: `第9条（著作权）`,
    article9Sentence1: `1.未经本公司事前同意，会员不得将通过使用本网站获得的全部内容以著作权规定的会员个人使用以外的目的进行使用。`,
    article9Sentence2: `2.如因违反本条规定产生纠纷的，会员应自行承担费用和责任解决该纠纷，且不得给本公司及第三方造成任何损害。`,
    mainTitle: `WAmazing免税EC服务使用条款`
  },
  vendor: {
    sugi: `SUGI杉药局 川口户塚店`,
    tokyu: `東急百货店`,
    wamazing: `玩尽日本购物`
  },
  wonderCompass: {
    discoverTheCharmOfJapan: (className: string) =>
      `凡参加免税商品取货体验活动的顾客，\n<span class=${className}>都可获赠日本人气伴手礼！</span>\n现场GET来自日本全国各地的伴手礼，感受日本魅力！`,
    justThreeMins: `仅需短短3分钟`,
    location: `WANDER COMPASS SHIBUYA位于涩谷109旁，在涩谷站A2出口的地下通道。`,
    overview: `活动详情`,
    title: `2023年9月30日前！现场取货体验活动！快来参加！`,
    contents: {
      address: `地址：Shibuya Station B1 floor, 2 Chome-1-1 Dōgenzaka, Tokyo`,
      period: `期间：2023/8/1〜2023/9/30`,
      place: `地点：WANDER COMPASS SHIBUYA`,
      time: `时间：10:00〜20:00`
    }
  },
  yamazakiGift: {
    period: `在4/8（周二）～4/21（周一）期间内下单，且在5/1（周四）～5/31（周六）期间内取货`,
    promotionDetails: `单笔消费满30,000日元并使用指定9折优惠券付款，就有机会成为20位幸运顾客之一，获赠超人气的「山崎威士忌」！`,
    conditions: {
      text1: `单笔消费满30,000日元`,
      text2: `付款时使用下方指定9折优惠券`
    },
    entryBotton: {
      text1: `已报名`,
      text2: `请在购物车页面输入专属优惠码`,
      text3: `优惠券的使用方法`,
      text4: `请点击这个按钮！`
    },
    meta: {
      title: `★消费满3万日元就有机会参加抽奖！为20名幸运用户送出「山崎威士忌」！★`
    },
    modal: {
      title: `感谢您的参加`
    },
    notes: {
      list1: `仅限使用优惠券的订单参与抽奖。`,
      list2: `优惠券不可用于医药品和酒类商品。`,
      list3: `若取消订单，将无法参加抽奖。`,
      list4: `订单成立后，商品内容、领取地点、领取时间无法更改。如需更改，请先取消订单，再重新下单。`,
      list5: `活动期间，每个用户即使多次消费，也仅有一次抽奖机会。`,
      list6: `登机随身行李携带及回国携带入境行李的相关事宜，须符合各国海关及各航司的行李规定。请在办理手续前自行确认相关规定。本店对登机随身行李、携带入境行李的相关事宜概不负责，敬请谅解。`,
      list7: `若因玩尽日本WAmazing的责任导致无法收到所订商品，赠品威士忌将更换为下次可使用的5,000日元优惠券（适用于满10,000日元的订单，不适用于医药品和酒类商品）。\n此外，您已购买的商品将提供退款或国际邮寄两种方式进行处理。具体事宜将由负责人日后与您联系确认。`,
      list8: `本活动可能会在未提前通知的情况下变更或结束。`,
      list9: `本次活动的最终解释权归玩尽日本WAmazing所有。`
    },
    prize: {
      list1: `获奖者将在取货日的3天前收到通知。`,
      list2: `奖品将与订购的其他商品一同发货。`,
      list3: `即使未能与获奖者取得联系，礼品也将与订购的商品一同放入免税袋中。`
    }
  },
  yearEndSale: {
    metaDescription: `【最高8折】岁末新春特惠商品，点亮您的节日季！！`,
    metaTitle: `岁末＆新春大感谢祭！`,
    popularProductsTitle: `热门推荐商品`,
    startShopping: `立即浏览人气商品！`
  }
} as const;
